// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2740%27 height=%2740%27 preserveAspectRatio=%27none%27 viewBox=%270 0 40 40%27%3E%3Cpath d=%27M9.4,12.3l10.4,10.4l10.4-10.4c0.2-0.2,0.5-0.4,0.9-0.4c0.3,0,0.6,0.1,0.9,0.4l3.3,3.3c0.2,0.2,0.4,0.5,0.4,0.9 c0,0.4-0.1,0.6-0.4,0.9L20.7,31.9c-0.2,0.2-0.5,0.4-0.9,0.4c-0.3,0-0.6-0.1-0.9-0.4L4.3,17.3c-0.2-0.2-0.4-0.5-0.4-0.9 c0-0.4,0.1-0.6,0.4-0.9l3.3-3.3c0.2-0.2,0.5-0.4,0.9-0.4S9.1,12.1,9.4,12.3z%27 fill=%27rgba%28210, 215, 217, 0.75%29%27 /%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*@import url("https://fonts.googleapis.com/css?family=Open+Sans:400,600,400italic,600italic|Roboto+Slab:400,700"); */

/*
	Editorial by HTML5 UP
	html5up.net | @ajlkn
	Free for personal and commercial use under the CCA 3.0 license (html5up.net/license)
*/
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
	margin: 0;
	padding: 0;
	/* border: 0; */
	font-size: 100%;
	font: inherit;
	vertical-align: baseline;
}

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
	display: block;
}

body {
	line-height: 1;
}

ol,
ul {
	list-style: none;
}

blockquote,
q {
	quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
	content: '';
	content: none;
}

table {
	border-collapse: collapse;
	border-spacing: 0;
}

body {
	-webkit-text-size-adjust: none;
}

/* Basic */

body {
	-ms-overflow-style: scrollbar;
}

@media screen and (max-width: 480px) {

	html,
	body {
		min-width: 320px;
	}
}

html {
	box-sizing: border-box;
}

*,
*:before,
*:after {
	box-sizing: inherit;
}

body {
	background: #ffffff;
}

/* Type */
body,
input,
select,
textarea {
	color: #7f888f;
	font-family: "Roboto", sans-serif;
	font-size: 13pt;
	font-weight: 400;
	line-height: 1.65;
}

@media screen and (max-width: 1680px) {
	body,
	input,
	select,
	textarea {
		font-size: 11pt;
	}
}

@media screen and (max-width: 1280px) {
	body,
	input,
	select,
	textarea {
		font-size: 10pt;
	}
}

@media screen and (max-width: 360px) {
	body,
	input,
	select,
	textarea {
		font-size: 9pt;
	}
}

a {
	transition: color 0.2s ease-in-out, border-bottom-color 0.2s ease-in-out;
	text-decoration: none;
}

strong,
b {
	color: #3d4449;
	font-weight: 600;
}

em,
i {
	font-style: italic;
}

p {
	margin: 0 0 2em 0;
}

h1,
h2,
h3,
h4,
h5,
h6 {
	color: #3d4449;
	font-family: "Roboto Slab", serif;
	font-weight: 700;
	line-height: 1.5;
	margin: 0 0 1em 0;
}

h1 a,
h2 a,
h3 a,
h4 a,
h5 a,
h6 a {
	color: inherit;
	text-decoration: none;
	border-bottom: 0;
}

h1 {
	font-size: 3em;
	margin: 0 0 0.5em 0;
	line-height: 1.3;
}

h2 {
	font-size: 1.75em;
}

h3 {
	font-size: 1.25em;
}

h4 {
	font-size: 1.1em;
}

h5 {
	font-size: 0.9em;
}

h6 {
	font-size: 0.7em;
}

@media screen and (max-width: 1680px) {
	h1 {
		font-size: 2.5em;
	}
}

@media screen and (max-width: 980px) {
	h1 {
		font-size: 2em;
	}
}

@media screen and (max-width: 736px) {
	h1 {
		font-size: 1.5em;
		line-height: 1.4;
	}

	h2 {
		font-size: 1.5em;
	}
}

sub {
	font-size: 0.8em;
	position: relative;
	top: 0.5em;
}

sup {
	font-size: 0.8em;
	position: relative;
	top: -0.5em;
}

blockquote {
	border-left: solid 3px rgba(210, 215, 217, 0.75);
	font-style: italic;
	margin: 0 0 2em 0;
	padding: 0.5em 0 0.5em 2em;
}

code {
	background: rgba(230, 235, 237, 0.25);
	border-radius: 0.375em;
	border: solid 1px rgba(210, 215, 217, 0.75);
	font-family: "Courier New", monospace;
	font-size: 0.9em;
	margin: 0 0.25em;
	padding: 0.25em 0.65em;
}

pre {
	-webkit-overflow-scrolling: touch;
	font-family: "Courier New", monospace;
	font-size: 0.9em;
	margin: 0 0 2em 0;
}

pre code {
	display: block;
	line-height: 1.75;
	padding: 1em 1.5em;
	overflow-x: auto;
}

hr {
	border: 0;
	border-bottom: solid 1px rgba(210, 215, 217, 0.75);
	margin: 2em 0;
}

hr.major {
	margin: 3em 0;
}

.align-left {
	text-align: left !important;
}

.align-center {
	text-align: center !important;
}

.align-right {
	margin-left: 78%;
}

/* Row */
.row {
	display: flex;
	flex-wrap: wrap;
	box-sizing: border-box;
	align-items: stretch;
}

.row>* {
	box-sizing: border-box;
}

.row.gtr-uniform>*> :last-child {
	margin-bottom: 0;
}

.row.aln-left {
	justify-content: flex-start;
}

.row.aln-center {
	justify-content: center;
}

.row.aln-right {
	justify-content: flex-end;
}

.row.aln-top {
	align-items: flex-start;
}

.row.aln-middle {
	align-items: center;
}

.row.aln-bottom {
	align-items: flex-end;
}

.row>.imp {
	order: -1;
}

.row>.col-1 {
	width: 8.33333%;
}

.row>.off-1 {
	margin-left: 8.33333%;
}

.row>.col-2 {
	width: 16.66667%;
}

.row>.off-2 {
	margin-left: 16.66667%;
}

.row>.col-3 {
	width: 25%;
}

.row>.off-3 {
	margin-left: 25%;
}

.row>.col-4 {
	width: 33.33333%;
}

.row>.off-4 {
	margin-left: 33.33333%;
}

.row>.col-5 {
	width: 41.66667%;
}

.row>.off-5 {
	margin-left: 41.66667%;
}

.row>.col-6 {
	width: 50%;
}

.row>.off-6 {
	margin-left: 50%;
}

.row>.col-7 {
	width: 58.33333%;
}

.row>.off-7 {
	margin-left: 58.33333%;
}

.row>.col-8 {
	width: 66.66667%;
}

.row>.off-8 {
	margin-left: 66.66667%;
}

.row>.col-9 {
	width: 75%;
}

.row>.off-9 {
	margin-left: 75%;
}

.row>.col-10 {
	width: 83.33333%;
}

.row>.off-10 {
	margin-left: 83.33333%;
}

.row>.col-11 {
	width: 91.66667%;
}

.row>.off-11 {
	margin-left: 91.66667%;
}

.row>.col-12 {
	width: 100%;
}

.row>.off-12 {
	margin-left: 100%;
}

.row.gtr-0 {
	margin-top: 0;
	margin-left: 0em;
}

.row.gtr-0>* {
	padding: 0 0 0 0em;
}

.row.gtr-0.gtr-uniform {
	margin-top: 0em;
}

.row.gtr-0.gtr-uniform>* {
	padding-top: 0em;
}

.row.gtr-25 {
	margin-top: 0;
	margin-left: -0.375em;
}

.row.gtr-25>* {
	padding: 0 0 0 0.375em;
}

.row.gtr-25.gtr-uniform {
	margin-top: -0.375em;
}

.row.gtr-25.gtr-uniform>* {
	padding-top: 0.375em;
}

.row.gtr-50 {
	margin-top: 0;
	margin-left: -0.75em;
}

.row.gtr-50>* {
	padding: 0 0 0 0.75em;
}

.row.gtr-50.gtr-uniform {
	margin-top: -0.75em;
}

.row.gtr-50.gtr-uniform>* {
	padding-top: 0.75em;
}

.row {
	margin-top: 0;
	margin-left: -1.5em;
}

.row>* {
	padding: 0 0 0 1.5em;
}

.row.gtr-uniform {
	margin-top: -1.5em;
}

.row.gtr-uniform>* {
	padding-top: 1.5em;
}

.row.gtr-150 {
	margin-top: 0;
	margin-left: -2.25em;
}

.row.gtr-150>* {
	padding: 0 0 0 2.25em;
}

.row.gtr-150.gtr-uniform {
	margin-top: -2.25em;
}

.row.gtr-150.gtr-uniform>* {
	padding-top: 2.25em;
}

.row.gtr-200 {
	margin-top: 0;
	margin-left: -3em;
}

.row.gtr-200>* {
	padding: 0 0 0 3em;
}

.row.gtr-200.gtr-uniform {
	margin-top: -3em;
}

.row.gtr-200.gtr-uniform>* {
	padding-top: 3em;
}

@media screen and (max-width: 1680px) {
	.row {
		display: flex;
		flex-wrap: wrap;
		box-sizing: border-box;
		align-items: stretch;
	}

	.row>* {
		box-sizing: border-box;
	}

	.row.gtr-uniform>*> :last-child {
		margin-bottom: 0;
	}

	.row.aln-left {
		justify-content: flex-start;
	}

	.row.aln-center {
		justify-content: center;
	}

	.row.aln-right {
		justify-content: flex-end;
	}

	.row.aln-top {
		align-items: flex-start;
	}

	.row.aln-middle {
		align-items: center;
	}

	.row.aln-bottom {
		align-items: flex-end;
	}

	.row>.imp-xlarge {
		order: -1;
	}

	.row>.col-1-xlarge {
		width: 8.33333%;
	}

	.row>.off-1-xlarge {
		margin-left: 8.33333%;
	}

	.row>.col-2-xlarge {
		width: 16.66667%;
	}

	.row>.off-2-xlarge {
		margin-left: 16.66667%;
	}

	.row>.col-3-xlarge {
		width: 25%;
	}

	.row>.off-3-xlarge {
		margin-left: 25%;
	}

	.row>.col-4-xlarge {
		width: 33.33333%;
	}

	.row>.off-4-xlarge {
		margin-left: 33.33333%;
	}

	.row>.col-5-xlarge {
		width: 41.66667%;
	}

	.row>.off-5-xlarge {
		margin-left: 41.66667%;
	}

	.row>.col-6-xlarge {
		width: 50%;
	}

	.row>.off-6-xlarge {
		margin-left: 50%;
	}

	.row>.col-7-xlarge {
		width: 58.33333%;
	}

	.row>.off-7-xlarge {
		margin-left: 58.33333%;
	}

	.row>.col-8-xlarge {
		width: 66.66667%;
	}

	.row>.off-8-xlarge {
		margin-left: 66.66667%;
	}

	.row>.col-9-xlarge {
		width: 75%;
	}

	.row>.off-9-xlarge {
		margin-left: 75%;
	}

	.row>.col-10-xlarge {
		width: 83.33333%;
	}

	.row>.off-10-xlarge {
		margin-left: 83.33333%;
	}

	.row>.col-11-xlarge {
		width: 91.66667%;
	}

	.row>.off-11-xlarge {
		margin-left: 91.66667%;
	}

	.row>.col-12-xlarge {
		width: 100%;
	}

	.row>.off-12-xlarge {
		margin-left: 100%;
	}

	.row.gtr-0 {
		margin-top: 0;
		margin-left: 0em;
	}

	.row.gtr-0>* {
		padding: 0 0 0 0em;
	}

	.row.gtr-0.gtr-uniform {
		margin-top: 0em;
	}

	.row.gtr-0.gtr-uniform>* {
		padding-top: 0em;
	}

	.row.gtr-25 {
		margin-top: 0;
		margin-left: -0.375em;
	}

	.row.gtr-25>* {
		padding: 0 0 0 0.375em;
	}

	.row.gtr-25.gtr-uniform {
		margin-top: -0.375em;
	}

	.row.gtr-25.gtr-uniform>* {
		padding-top: 0.375em;
	}

	.row.gtr-50 {
		margin-top: 0;
		margin-left: -0.75em;
	}

	.row.gtr-50>* {
		padding: 0 0 0 0.75em;
	}

	.row.gtr-50.gtr-uniform {
		margin-top: -0.75em;
	}

	.row.gtr-50.gtr-uniform>* {
		padding-top: 0.75em;
	}

	.row {
		margin-top: 0;
		margin-left: -15px;
		margin-right: 1px;
	}

	.row>* {
		padding: 0 0 0 15px;
	}

	.row.gtr-uniform {
		margin-top: -1.5em;
	}

	.row.gtr-uniform>* {
		padding-top: 1.5em;
	}

	.row.gtr-150 {
		margin-top: 0;
		margin-left: -2.25em;
	}

	.row.gtr-150>* {
		padding: 0 0 0 2.25em;
	}

	.row.gtr-150.gtr-uniform {
		margin-top: -2.25em;
	}

	.row.gtr-150.gtr-uniform>* {
		padding-top: 2.25em;
	}

	.row.gtr-200 {
		margin-top: 0;
		margin-left: -3em;
	}

	.row.gtr-200>* {
		padding: 0 0 0 3em;
	}

	.row.gtr-200.gtr-uniform {
		margin-top: -3em;
	}

	.row.gtr-200.gtr-uniform>* {
		padding-top: 3em;
	}
}

@media screen and (max-width: 1280px) {
	.row {
		display: flex;
		flex-wrap: wrap;
		box-sizing: border-box;
		align-items: stretch;
	}

	.row>* {
		box-sizing: border-box;
	}

	.row.gtr-uniform>*> :last-child {
		margin-bottom: 0;
	}

	.row.aln-left {
		justify-content: flex-start;
	}

	.row.aln-center {
		justify-content: center;
	}

	.row.aln-right {
		justify-content: flex-end;
	}

	.row.aln-top {
		align-items: flex-start;
	}

	.row.aln-middle {
		align-items: center;
	}

	.row.aln-bottom {
		align-items: flex-end;
	}

	.row>.imp-large {
		order: -1;
	}

	.row>.col-1-large {
		width: 8.33333%;
	}

	.row>.off-1-large {
		margin-left: 8.33333%;
	}

	.row>.col-2-large {
		width: 16.66667%;
	}

	.row>.off-2-large {
		margin-left: 16.66667%;
	}

	.row>.col-3-large {
		width: 25%;
	}

	.row>.off-3-large {
		margin-left: 25%;
	}

	.row>.col-4-large {
		width: 33.33333%;
	}

	.row>.off-4-large {
		margin-left: 33.33333%;
	}

	.row>.col-5-large {
		width: 41.66667%;
	}

	.row>.off-5-large {
		margin-left: 41.66667%;
	}

	.row>.col-6-large {
		width: 50%;
	}

	.row>.off-6-large {
		margin-left: 50%;
	}

	.row>.col-7-large {
		width: 58.33333%;
	}

	.row>.off-7-large {
		margin-left: 58.33333%;
	}

	.row>.col-8-large {
		width: 66.66667%;
	}

	.row>.off-8-large {
		margin-left: 66.66667%;
	}

	.row>.col-9-large {
		width: 75%;
	}

	.row>.off-9-large {
		margin-left: 75%;
	}

	.row>.col-10-large {
		width: 83.33333%;
	}

	.row>.off-10-large {
		margin-left: 83.33333%;
	}

	.row>.col-11-large {
		width: 91.66667%;
	}

	.row>.off-11-large {
		margin-left: 91.66667%;
	}

	.row>.col-12-large {
		width: 100%;
	}

	.row>.off-12-large {
		margin-left: 100%;
	}

	.row.gtr-0 {
		margin-top: 0;
		margin-left: 0em;
	}

	.row.gtr-0>* {
		padding: 0 0 0 0em;
	}

	.row.gtr-0.gtr-uniform {
		margin-top: 0em;
	}

	.row.gtr-0.gtr-uniform>* {
		padding-top: 0em;
	}

	.row.gtr-25 {
		margin-top: 0;
		margin-left: -0.375em;
	}

	.row.gtr-25>* {
		padding: 0 0 0 0.375em;
	}

	.row.gtr-25.gtr-uniform {
		margin-top: -0.375em;
	}

	.row.gtr-25.gtr-uniform>* {
		padding-top: 0.375em;
	}

	.row.gtr-50 {
		margin-top: 0;
		margin-left: -0.75em;
	}

	.row.gtr-50>* {
		padding: 0 0 0 0.75em;
	}

	.row.gtr-50.gtr-uniform {
		margin-top: -0.75em;
	}

	.row.gtr-50.gtr-uniform>* {
		padding-top: 0.75em;
	}

	.row {
		margin-top: 0;
		margin-left: -1.5em;
	}

	.row>* {
		padding: 0 0 0 1.5em;
	}

	.row.gtr-uniform {
		margin-top: -1.5em;
	}

	.row.gtr-uniform>* {
		padding-top: 1.5em;
	}

	.row.gtr-150 {
		margin-top: 0;
		margin-left: -2.25em;
	}

	.row.gtr-150>* {
		padding: 0 0 0 2.25em;
	}

	.row.gtr-150.gtr-uniform {
		margin-top: -2.25em;
	}

	.row.gtr-150.gtr-uniform>* {
		padding-top: 2.25em;
	}

	.row.gtr-200 {
		margin-top: 0;
		margin-left: -3em;
	}

	.row.gtr-200>* {
		padding: 0 0 0 3em;
	}

	.row.gtr-200.gtr-uniform {
		margin-top: -3em;
	}

	.row.gtr-200.gtr-uniform>* {
		padding-top: 3em;
	}
}

@media screen and (max-width: 980px) {
	.row {
		display: flex;
		flex-wrap: wrap;
		box-sizing: border-box;
		align-items: stretch;
	}

	.row>* {
		box-sizing: border-box;
	}

	.row.gtr-uniform>*> :last-child {
		margin-bottom: 0;
	}

	.row.aln-left {
		justify-content: flex-start;
	}

	.row.aln-center {
		justify-content: center;
	}

	.row.aln-right {
		justify-content: flex-end;
	}

	.row.aln-top {
		align-items: flex-start;
	}

	.row.aln-middle {
		align-items: center;
	}

	.row.aln-bottom {
		align-items: flex-end;
	}

	.row>.imp-medium {
		order: -1;
	}

	.row>.col-1-medium {
		width: 8.33333%;
	}

	.row>.off-1-medium {
		margin-left: 8.33333%;
	}

	.row>.col-2-medium {
		width: 16.66667%;
	}

	.row>.off-2-medium {
		margin-left: 16.66667%;
	}

	.row>.col-3-medium {
		width: 25%;
	}

	.row>.off-3-medium {
		margin-left: 25%;
	}

	.row>.col-4-medium {
		width: 33.33333%;
	}

	.row>.off-4-medium {
		margin-left: 33.33333%;
	}

	.row>.col-5-medium {
		width: 41.66667%;
	}

	.row>.off-5-medium {
		margin-left: 41.66667%;
	}

	.row>.col-6-medium {
		width: 50%;
	}

	.row>.off-6-medium {
		margin-left: 50%;
	}

	.row>.col-7-medium {
		width: 58.33333%;
	}

	.row>.off-7-medium {
		margin-left: 58.33333%;
	}

	.row>.col-8-medium {
		width: 66.66667%;
	}

	.row>.off-8-medium {
		margin-left: 66.66667%;
	}

	.row>.col-9-medium {
		width: 75%;
	}

	.row>.off-9-medium {
		margin-left: 75%;
	}

	.row>.col-10-medium {
		width: 83.33333%;
	}

	.row>.off-10-medium {
		margin-left: 83.33333%;
	}

	.row>.col-11-medium {
		width: 91.66667%;
	}

	.row>.off-11-medium {
		margin-left: 91.66667%;
	}

	.row>.col-12-medium {
		width: 100%;
	}

	.row>.off-12-medium {
		margin-left: 100%;
	}

	.row.gtr-0 {
		margin-top: 0;
		margin-left: 0em;
	}

	.row.gtr-0>* {
		padding: 0 0 0 0em;
	}

	.row.gtr-0.gtr-uniform {
		margin-top: 0em;
	}

	.row.gtr-0.gtr-uniform>* {
		padding-top: 0em;
	}

	.row.gtr-25 {
		margin-top: 0;
		margin-left: -0.375em;
	}

	.row.gtr-25>* {
		padding: 0 0 0 0.375em;
	}

	.row.gtr-25.gtr-uniform {
		margin-top: -0.375em;
	}

	.row.gtr-25.gtr-uniform>* {
		padding-top: 0.375em;
	}

	.row.gtr-50 {
		margin-top: 0;
		margin-left: -0.75em;
	}

	.row.gtr-50>* {
		padding: 0 0 0 0.75em;
	}

	.row.gtr-50.gtr-uniform {
		margin-top: -0.75em;
	}

	.row.gtr-50.gtr-uniform>* {
		padding-top: 0.75em;
	}

	.row {
		margin-top: 0;
		margin-left: -1.5em;
	}

	.row>* {
		padding: 0 0 0 1.5em;
	}

	.row.gtr-uniform {
		margin-top: -1.5em;
	}

	.row.gtr-uniform>* {
		padding-top: 1.5em;
	}

	.row.gtr-150 {
		margin-top: 0;
		margin-left: -2.25em;
	}

	.row.gtr-150>* {
		padding: 0 0 0 2.25em;
	}

	.row.gtr-150.gtr-uniform {
		margin-top: -2.25em;
	}

	.row.gtr-150.gtr-uniform>* {
		padding-top: 2.25em;
	}

	.row.gtr-200 {
		margin-top: 0;
		margin-left: -3em;
	}

	.row.gtr-200>* {
		padding: 0 0 0 3em;
	}

	.row.gtr-200.gtr-uniform {
		margin-top: -3em;
	}

	.row.gtr-200.gtr-uniform>* {
		padding-top: 3em;
	}
}

@media screen and (max-width: 736px) {
	.row {
		display: flex;
		flex-wrap: wrap;
		box-sizing: border-box;
		align-items: stretch;
	}

	.row>* {
		box-sizing: border-box;
	}

	.row.gtr-uniform>*> :last-child {
		margin-bottom: 0;
	}

	.row.aln-left {
		justify-content: flex-start;
	}

	.row.aln-center {
		justify-content: center;
	}

	.row.aln-right {
		justify-content: flex-end;
	}

	.row.aln-top {
		align-items: flex-start;
	}

	.row.aln-middle {
		align-items: center;
	}

	.row.aln-bottom {
		align-items: flex-end;
	}

	.row>.imp-small {
		order: -1;
	}

	.row>.col-1-small {
		width: 8.33333%;
	}

	.row>.off-1-small {
		margin-left: 8.33333%;
	}

	.row>.col-2-small {
		width: 16.66667%;
	}

	.row>.off-2-small {
		margin-left: 16.66667%;
	}

	.row>.col-3-small {
		width: 25%;
	}

	.row>.off-3-small {
		margin-left: 25%;
	}

	.row>.col-4-small {
		width: 33.33333%;
	}

	.row>.off-4-small {
		margin-left: 33.33333%;
	}

	.row>.col-5-small {
		width: 41.66667%;
	}

	.row>.off-5-small {
		margin-left: 41.66667%;
	}

	.row>.col-6-small {
		width: 50%;
	}

	.row>.off-6-small {
		margin-left: 50%;
	}

	.row>.col-7-small {
		width: 58.33333%;
	}

	.row>.off-7-small {
		margin-left: 58.33333%;
	}

	.row>.col-8-small {
		width: 66.66667%;
	}

	.row>.off-8-small {
		margin-left: 66.66667%;
	}

	.row>.col-9-small {
		width: 75%;
	}

	.row>.off-9-small {
		margin-left: 75%;
	}

	.row>.col-10-small {
		width: 83.33333%;
	}

	.row>.off-10-small {
		margin-left: 83.33333%;
	}

	.row>.col-11-small {
		width: 91.66667%;
	}

	.row>.off-11-small {
		margin-left: 91.66667%;
	}

	.row>.col-12-small {
		width: 100%;
	}

	.row>.off-12-small {
		margin-left: 100%;
	}

	.row.gtr-0 {
		margin-top: 0;
		margin-left: 0em;
	}

	.row.gtr-0>* {
		padding: 0 0 0 0em;
	}

	.row.gtr-0.gtr-uniform {
		margin-top: 0em;
	}

	.row.gtr-0.gtr-uniform>* {
		padding-top: 0em;
	}

	.row.gtr-25 {
		margin-top: 0;
		margin-left: -0.375em;
	}

	.row.gtr-25>* {
		padding: 0 0 0 0.375em;
	}

	.row.gtr-25.gtr-uniform {
		margin-top: -0.375em;
	}

	.row.gtr-25.gtr-uniform>* {
		padding-top: 0.375em;
	}

	.row.gtr-50 {
		margin-top: 0;
		margin-left: -0.75em;
	}

	.row.gtr-50>* {
		padding: 0 0 0 0.75em;
	}

	.row.gtr-50.gtr-uniform {
		margin-top: -0.75em;
	}

	.row.gtr-50.gtr-uniform>* {
		padding-top: 0.75em;
	}

	.row {
		margin-top: 0;
		margin-left: -1.5em;
	}

	.row>* {
		padding: 0 0 0 1.5em;
	}

	.row.gtr-uniform {
		margin-top: -1.5em;
	}

	.row.gtr-uniform>* {
		padding-top: 1.5em;
	}

	.row.gtr-150 {
		margin-top: 0;
		margin-left: -2.25em;
	}

	.row.gtr-150>* {
		padding: 0 0 0 2.25em;
	}

	.row.gtr-150.gtr-uniform {
		margin-top: -2.25em;
	}

	.row.gtr-150.gtr-uniform>* {
		padding-top: 2.25em;
	}

	.row.gtr-200 {
		margin-top: 0;
		margin-left: -3em;
	}

	.row.gtr-200>* {
		padding: 0 0 0 3em;
	}

	.row.gtr-200.gtr-uniform {
		margin-top: -3em;
	}

	.row.gtr-200.gtr-uniform>* {
		padding-top: 3em;
	}
}

@media screen and (max-width: 480px) {
	.row {
		display: flex;
		flex-wrap: wrap;
		box-sizing: border-box;
		align-items: stretch;
	}

	.row>* {
		box-sizing: border-box;
	}

	.row.gtr-uniform>*> :last-child {
		margin-bottom: 0;
	}

	.row.aln-left {
		justify-content: flex-start;
	}

	.row.aln-center {
		justify-content: center;
	}

	.row.aln-right {
		justify-content: flex-end;
	}

	.row.aln-top {
		align-items: flex-start;
	}

	.row.aln-middle {
		align-items: center;
	}

	.row.aln-bottom {
		align-items: flex-end;
	}

	.row>.imp-xsmall {
		order: -1;
	}

	.row>.col-1-xsmall {
		width: 8.33333%;
	}

	.row>.off-1-xsmall {
		margin-left: 8.33333%;
	}

	.row>.col-2-xsmall {
		width: 16.66667%;
	}

	.row>.off-2-xsmall {
		margin-left: 16.66667%;
	}

	.row>.col-3-xsmall {
		width: 25%;
	}

	.row>.off-3-xsmall {
		margin-left: 25%;
	}

	.row>.col-4-xsmall {
		width: 33.33333%;
	}

	.row>.off-4-xsmall {
		margin-left: 33.33333%;
	}

	.row>.col-5-xsmall {
		width: 41.66667%;
	}

	.row>.off-5-xsmall {
		margin-left: 41.66667%;
	}

	.row>.col-6-xsmall {
		width: 50%;
	}

	.row>.off-6-xsmall {
		margin-left: 50%;
	}

	.row>.col-7-xsmall {
		width: 58.33333%;
	}

	.row>.off-7-xsmall {
		margin-left: 58.33333%;
	}

	.row>.col-8-xsmall {
		width: 66.66667%;
	}

	.row>.off-8-xsmall {
		margin-left: 66.66667%;
	}

	.row>.col-9-xsmall {
		width: 75%;
	}

	.row>.off-9-xsmall {
		margin-left: 75%;
	}

	.row>.col-10-xsmall {
		width: 83.33333%;
	}

	.row>.off-10-xsmall {
		margin-left: 83.33333%;
	}

	.row>.col-11-xsmall {
		width: 91.66667%;
	}

	.row>.off-11-xsmall {
		margin-left: 91.66667%;
	}

	.row>.col-12-xsmall {
		width: 100%;
	}

	.row>.off-12-xsmall {
		margin-left: 100%;
	}

	.row.gtr-0 {
		margin-top: 0;
		margin-left: 0em;
	}

	.row.gtr-0>* {
		padding: 0 0 0 0em;
	}

	.row.gtr-0.gtr-uniform {
		margin-top: 0em;
	}

	.row.gtr-0.gtr-uniform>* {
		padding-top: 0em;
	}

	.row.gtr-25 {
		margin-top: 0;
		margin-left: -0.375em;
	}

	.row.gtr-25>* {
		padding: 0 0 0 0.375em;
	}

	.row.gtr-25.gtr-uniform {
		margin-top: -0.375em;
	}

	.row.gtr-25.gtr-uniform>* {
		padding-top: 0.375em;
	}

	.row.gtr-50 {
		margin-top: 0;
		margin-left: -0.75em;
	}

	.row.gtr-50>* {
		padding: 0 0 0 0.75em;
	}

	.row.gtr-50.gtr-uniform {
		margin-top: -0.75em;
	}

	.row.gtr-50.gtr-uniform>* {
		padding-top: 0.75em;
	}

	.row {
		margin-top: 0;
		margin-left: -1.5em;
	}

	.row>* {
		padding: 0 0 0 1.5em;
	}

	.row.gtr-uniform {
		margin-top: -1.5em;
	}

	.row.gtr-uniform>* {
		padding-top: 1.5em;
	}

	.row.gtr-150 {
		margin-top: 0;
		margin-left: -2.25em;
	}

	.row.gtr-150>* {
		padding: 0 0 0 2.25em;
	}

	.row.gtr-150.gtr-uniform {
		margin-top: -2.25em;
	}

	.row.gtr-150.gtr-uniform>* {
		padding-top: 2.25em;
	}

	.row.gtr-200 {
		margin-top: 0;
		margin-left: -3em;
	}

	.row.gtr-200>* {
		padding: 0 0 0 3em;
	}

	.row.gtr-200.gtr-uniform {
		margin-top: -3em;
	}

	.row.gtr-200.gtr-uniform>* {
		padding-top: 3em;
	}
}

/* Section/Article */
section.special,
article.special {
	text-align: center;
}

header p {
	font-family: "Roboto Slab", serif;
	font-size: 1em;
	font-weight: 400;
	letter-spacing: 0.075em;
	margin-top: -0.5em;
	text-transform: uppercase;
}

header.major> :last-child {
	border-bottom: solid 3px #f56a6a;
	display: inline-block;
	margin: 0 0 2em 0;
	padding: 0 0.75em 0.5em 0;
}

header.main> :last-child {
	margin: 0 0 1em 0;
}

/* Form */
form {
	margin: 2em 0 2em 0;
}

label {
	color: #3d4449;
	display: block;
	font-size: 0.9em;
	font-weight: 600;
	margin: 0 0 1em 0;
}

input[type="text"],
input[type="password"],
input[type="email"],
input[type="tel"],
input[type="search"],
input[type="url"],
select,
textarea {
	appearance: none;
	background: #ffffff;
	border-radius: 0.375em;
	border: none;
	border: solid 1px rgba(210, 215, 217, 0.75);
	color: inherit;
	display: block;
	outline: 0;
	padding: 0 1em;
	text-decoration: none;
	width: -webkit-fill-available;
}

input[type="text"]:invalid,
input[type="password"]:invalid,
input[type="email"]:invalid,
input[type="tel"]:invalid,
input[type="search"]:invalid,
input[type="url"]:invalid,
select:invalid,
textarea:invalid {
	box-shadow: none;
}

input[type="text"]:focus,
input[type="password"]:focus,
input[type="email"]:focus,
input[type="tel"]:focus,
input[type="search"]:focus,
input[type="url"]:focus,
select:focus,
textarea:focus {
	border-color: #f56a6a;
	box-shadow: 0 0 0 1px #f56a6a;
}

select {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
	background-size: 1.25em;
	background-repeat: no-repeat;
	background-position: calc(100% - 1em) center;
	height: 2.75em;
	padding-right: 2.75em;
	text-overflow: ellipsis;
}

select option {
	color: #3d4449;
	background: #ffffff;
}

select:focus::-ms-value {
	background-color: transparent;
}

select::-ms-expand {
	display: none;
}

input[type="text"],
input[type="password"],
input[type="email"],
input[type="tel"],
input[type="search"],
input[type="url"],
select {
	height: 2.75em;
}

textarea {
	padding: 0.75em 1em;
}

input[type="checkbox"],
input[type="radio"] {
	appearance: none;
	display: block;
	float: left;
	margin-right: -2em;
	opacity: 0;
	width: 1em;
	z-index: -1;
}

input[type="checkbox"]+label,
input[type="radio"]+label {
	text-decoration: none;
	color: #7f888f;
	cursor: pointer;
	display: inline-block;
	font-size: 1em;
	font-weight: 400;
	padding-left: 1.5em;
	padding-right: 0.75em;
	position: relative;
}

input[type="checkbox"]+label:before,
input[type="radio"]+label:before {
	-moz-osx-font-smoothing: grayscale;
	-webkit-font-smoothing: antialiased;
	display: inline-block;
	font-style: normal;
	font-variant: normal;
	text-rendering: auto;
	line-height: 1;
	text-transform: none !important;
	font-family: 'Font Awesome 5 Free';
	font-weight: 900;
}

input[type="checkbox"]+label:before,
input[type="radio"]+label:before {
	background: #ffffff;
	border-radius: 0.375em;
	border: solid 1px rgba(210, 215, 217, 0.75);
	content: '';
	display: inline-block;
	font-size: 0.8em;
	height: 2.0625em;
	left: 0;
	line-height: 2.0625em;
	position: absolute;
	text-align: center;
	top: 0;
	width: 2.0625em;
}

input[type="checkbox"]:checked+label:before,
input[type="radio"]:checked+label:before {
	background: #3d4449;
	border-color: #3d4449;
	color: #ffffff;
	content: 'X';
}

input[type="checkbox"]:focus+label:before,
input[type="radio"]:focus+label:before {
	border-color: #f56a6a;
	box-shadow: 0 0 0 1px #f56a6a;
}

input[type="checkbox"]+label:before {
	border-radius: 0.375em;
}

input[type="radio"]+label:before {
	border-radius: 100%;
}

::-webkit-input-placeholder {
	color: #9fa3a6 !important;
	opacity: 1.0;
}

:-moz-placeholder {
	color: #9fa3a6 !important;
	opacity: 1.0;
}

::-moz-placeholder {
	color: #9fa3a6 !important;
	opacity: 1.0;
}

:-ms-input-placeholder {
	color: #9fa3a6 !important;
	opacity: 1.0;
}

/* Box */
.box {
	border-radius: 0.375em;
	border: solid 1px rgba(210, 215, 217, 0.75);
	margin-bottom: 2em;
	padding: 1.5em;
}

.box> :last-child,
.box> :last-child> :last-child,
.box> :last-child> :last-child> :last-child {
	margin-bottom: 0;
}

.box.alt {
	border: 0;
	border-radius: 0;
	padding: 0;
}

/* Icon */
.icon {
	text-decoration: none;
	border-bottom: none;
	position: relative;
}

.icon:before {
	-moz-osx-font-smoothing: grayscale;
	-webkit-font-smoothing: antialiased;
	display: inline-block;
	font-style: normal;
	font-variant: normal;
	text-rendering: auto;
	line-height: 1;
	text-transform: none !important;
	font-family: 'Font Awesome 5 Free';
	font-weight: 400;
}

.icon>.label {
	display: none;
}

.icon:before {
	line-height: inherit;
}

.icon.solid:before {
	font-weight: 900;
}

.icon.brands:before {
	font-family: 'Font Awesome 5 Brands';
}

/* Image */
.image {
	border-radius: 0.375em;
	border: 0;
	display: inline-block;
	position: relative;
}

.image img {
	border-radius: 0.375em;
	display: block;
}

.image.left,
.image.right {
	max-width: 40%;
}

.image.left img,
.image.right img {
	width: 100%;
}

.image.left {
	float: left;
	padding: 0 1.5em 1em 0;
	top: 0.25em;
}

.image.right {
	float: right;
	padding: 0 0 1em 1.5em;
	top: 0.25em;
}

.image.fit {
	display: block;
	margin: 0 0 2em 0;
	width: 100%;
}

.image.fit img {
	width: 100%;
}

.image.main {
	display: block;
	margin: 0 0 3em 0;
	width: 100%;
}

.image.main img {
	width: 100%;
}

a.image {
	overflow: hidden;
}

a.image img {
	transition: transform 0.2s ease;
}

a.image:hover img {
	transform: scale(1.075);
}

/* List */
ol {
	list-style: decimal;
	margin: 0 0 2em 0;
	padding-left: 1.25em;
}

ol li {
	padding-left: 0.25em;
}

ul {
	list-style: disc;
	margin: 0 0 0 0;
	padding-left: 1em;
}

ul li {
	padding-left: 0.5em;
}

ul.alt {
	list-style: none;
	padding-left: 0;
}

ul.alt li {
	border-top: solid 1px rgba(210, 215, 217, 0.75);
	padding: 0.5em 0;
}

ul.alt li:first-child {
	border-top: 0;
	padding-top: 0;
}

dl {
	margin: 0 0 2em 0;
}

dl dt {
	display: block;
	font-weight: 600;
	margin: 0 0 1em 0;
}

dl dd {
	margin-left: 2em;
}

/* Actions */
ul.actions {
	display: -moz-flex;
	display: -ms-flex;
	display: flex;
	cursor: default;
	list-style: none;
	margin-left: -1em;
	padding-left: 0;
}

ul.actions li {
	padding: 0 0 0 1em;
	vertical-align: middle;
}

ul.actions.special {
	-moz-justify-content: center;
	-ms-justify-content: center;
	justify-content: center;
	width: 100%;
	margin-left: 0;
}

ul.actions.special li:first-child {
	padding-left: 0;
}

ul.actions.stacked {
	-moz-flex-direction: column;
	flex-direction: column;
	margin-left: 0;
}

ul.actions.stacked li {
	padding: 1.3em 0 0 0;
}

ul.actions.stacked li:first-child {
	padding-top: 0;
}

ul.actions.fit {
	width: calc(100% + 1em);
}

ul.actions.fit li {
	-moz-flex-grow: 1;
	-ms-flex-grow: 1;
	flex-grow: 1;
	-ms-flex-shrink: 1;
	flex-shrink: 1;
	width: 100%;
}

ul.actions.fit li>* {
	width: 100%;
}

ul.actions.fit.stacked {
	width: 100%;
}

/* Icons */
ul.icons {
	cursor: default;
	list-style: none;
	padding-left: 0;
}

ul.icons li {
	display: inline-block;
	padding: 0 1em 0 0;
}

ul.icons li:last-child {
	padding-right: 0;
}

ul.icons li .icon {
	color: inherit;
}

ul.icons li .icon:before {
	font-size: 1.25em;
}

/* Contact */
ul.contact {
	list-style: none;
	padding: 0;
}

ul.contact li {
	text-decoration: none;
	border-top: solid 1px rgba(210, 215, 217, 0.75);
	margin: 1.5em 0 0 0;
	padding: 1.5em 0 0 3em;
	position: relative;
}

ul.contact li:before {
	-moz-osx-font-smoothing: grayscale;
	-webkit-font-smoothing: antialiased;
	display: inline-block;
	font-style: normal;
	font-variant: normal;
	text-rendering: auto;
	line-height: 1;
	text-transform: none !important;
	font-family: 'Font Awesome 5 Free';
	font-weight: 400;
}

ul.contact li:before {
	color: #f56a6a;
	display: inline-block;
	font-size: 1.5em;
	height: 1.125em;
	left: 0;
	line-height: 1.125em;
	position: absolute;
	text-align: center;
	top: 1em;
	width: 1.5em;
}

ul.contact li:first-child {
	border-top: 0;
	margin-top: 0;
	padding-top: 0;
}

ul.contact li:first-child:before {
	top: 0;
}

ul.contact li a {
	color: inherit;
}

/* Pagination */
ul.pagination {
	cursor: default;
	list-style: none;
	padding-left: 0;
}

ul.pagination li {
	display: inline-block;
	padding-left: 0;
	vertical-align: middle;
}

ul.pagination li>.page {
	transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;
	border-bottom: 0;
	border-radius: 0.375em;
	display: inline-block;
	font-size: 0.8em;
	font-weight: 600;
	height: 2em;
	line-height: 2em;
	margin: 0 0.125em;
	min-width: 2em;
	padding: 0 0.5em;
	text-align: center;
}

ul.pagination li>.page.active {
	background-color: #f56a6a;
	color: #ffffff !important;
}

ul.pagination li>.page.active:hover {
	background-color: #f67878;
}

ul.pagination li>.page.active:active {
	background-color: #f45c5c;
}

ul.pagination li:first-child {
	padding-right: 0.75em;
}

ul.pagination li:last-child {
	padding-left: 0.75em;
}

@media screen and (max-width: 480px) {
	ul.pagination li:nth-child(n+2):nth-last-child(n+2) {
		display: none;
	}

	ul.pagination li:first-child {
		padding-right: 0;
	}
}

/* Table */
.table-wrapper {
	-webkit-overflow-scrolling: touch;
	overflow-x: auto;
}

table {
	margin: 0 0 2em 0;
	width: 100%;
}

table tbody tr {
	border: solid 1px rgba(210, 215, 217, 0.75);
	border-left: 0;
	border-right: 0;
}

table tbody tr:nth-child(2n + 1) {
	background-color: rgba(230, 235, 237, 0.25);
}

table td {
	padding: 0.75em 0.75em;
}

table th {
	color: #3d4449;
	font-size: 0.9em;
	font-weight: 600;
	padding: 0 0.75em 0.75em 0.75em;
	text-align: left;
}

table thead {
	border-bottom: solid 2px rgba(210, 215, 217, 0.75);
}

table tfoot {
	border-top: solid 2px rgba(210, 215, 217, 0.75);
}

table.alt {
	border-collapse: separate;
}

table.alt tbody tr td {
	border: solid 1px rgba(210, 215, 217, 0.75);
	border-left-width: 0;
	border-top-width: 0;
}

table.alt tbody tr td:first-child {
	border-left-width: 1px;
}

table.alt tbody tr:first-child td {
	border-top-width: 1px;
}

table.alt thead {
	border-bottom: 0;
}

table.alt tfoot {
	border-top: 0;
}

/* Features */
.features {
	display: -moz-flex;
	display: -ms-flex;
	display: flex;
	flex-wrap: wrap;
	margin: 0 0 2em -3em;
	width: calc(100% + 3em);
}

.features article {
	-moz-align-items: center;
	-ms-align-items: center;
	align-items: center;
	display: -moz-flex;
	display: -ms-flex;
	display: flex;
	margin: 0 0 3em 3em;
	position: relative;
	width: calc(50% - 3em);
}

.features article:nth-child(2n - 1) {
	margin-right: 1.5em;
}

.features article:nth-child(2n) {
	margin-left: 1.5em;
}

.features article:nth-last-child(1),
.features article:nth-last-child(2) {
	margin-bottom: 0;
}

.features article .icon {
	-moz-flex-grow: 0;
	-ms-flex-grow: 0;
	flex-grow: 0;
	-ms-flex-shrink: 0;
	flex-shrink: 0;
	display: block;
	height: 10em;
	line-height: 10em;
	margin: 0 2em 0 0;
	text-align: center;
	width: 10em;
}

.features article .icon:before {
	color: #f56a6a;
	font-size: 2.75rem;
	position: relative;
	top: 0.05em;
}

.features article .icon:after {
	transform: rotate(45deg);
	border-radius: 0.25rem;
	border: solid 2px rgba(210, 215, 217, 0.75);
	content: '';
	display: block;
	height: 7em;
	left: 50%;
	margin: -3.5em 0 0 -3.5em;
	position: absolute;
	top: 50%;
	width: 7em;
}

.features article .content {
	-moz-flex-grow: 1;
	-ms-flex-grow: 1;
	flex-grow: 1;
	-ms-flex-shrink: 1;
	flex-shrink: 1;
	width: 100%;
}

.features article .content> :last-child {
	margin-bottom: 0;
}

@media screen and (max-width: 980px) {
	.features {
		margin: 0 0 2em 0;
		width: 100%;
	}

	.features article {
		margin: 0 0 3em 0;
		width: 100%;
	}

	.features article:nth-child(2n - 1) {
		margin-right: 0;
	}

	.features article:nth-child(2n) {
		margin-left: 0;
	}

	.features article:nth-last-child(1),
	.features article:nth-last-child(2) {
		margin-bottom: 3em;
	}

	.features article:last-child {
		margin-bottom: 0;
	}

	.features article .icon {
		height: 8em;
		line-height: 8em;
		width: 8em;
	}

	.features article .icon:before {
		font-size: 2.25rem;
	}

	.features article .icon:after {
		height: 6em;
		margin: -3em 0 0 -3em;
		width: 6em;
	}
}

@media screen and (max-width: 480px) {
	.features article {
		-moz-flex-direction: column;
		flex-direction: column;
		-moz-align-items: -moz-flex-start;
		-ms-align-items: -ms-flex-start;
		align-items: flex-start;
	}

	.features article .icon {
		height: 6em;
		line-height: 6em;
		margin: 0 0 1.5em 0;
		width: 6em;
	}

	.features article .icon:before {
		font-size: 1.5rem;
	}

	.features article .icon:after {
		height: 4em;
		margin: -2em 0 0 -2em;
		width: 4em;
	}
}

@media screen and (max-width: 480px) {
	.features article .icon:before {
		font-size: 1.25rem;
	}
}

/* Posts */
.posts {
	display: -moz-flex;
	display: -ms-flex;
	display: flex;
	flex-wrap: wrap;
	/* margin: 0 0 2em -6em; */
	/* width: calc(100% + 6em); */
}

.posts article {
	-moz-flex-grow: 0;
	-ms-flex-grow: 0;
	flex-grow: 0;
	-ms-flex-shrink: 1;
	flex-shrink: 1;
	margin: 0 0 6em 6em;
	position: relative;
	width: calc(33.33333% - 6em);
}

.posts article:before {
	background: rgba(210, 215, 217, 0.75);
	content: '';
	display: block;
	height: calc(100% + 6em);
	left: -3em;
	position: absolute;
	top: 0;
	width: 1px;
}

.posts article:after {
	background: rgba(210, 215, 217, 0.75);
	bottom: -3em;
	content: '';
	display: block;
	height: 1px;
	position: absolute;
	right: 0;
	width: calc(100% + 6em);
}

.posts article> :last-child {
	margin-bottom: 0;
}

.posts article .image {
	display: block;
	margin: 0 0 2em 0;
}

.posts article .image img {
	display: block;
	width: 100%;
}

@media screen and (min-width: 1681px) {
	.posts article:nth-child(3n + 1):before {
		display: none;
	}

	.posts article:nth-child(3n + 1):after {
		width: 100%;
	}

	.posts article:nth-last-child(1),
	.posts article:nth-last-child(2),
	.posts article:nth-last-child(3) {
		margin-bottom: 0;
	}

	.posts article:nth-last-child(1):before,
	.posts article:nth-last-child(2):before,
	.posts article:nth-last-child(3):before {
		height: 100%;
	}

	.posts article:nth-last-child(1):after,
	.posts article:nth-last-child(2):after,
	.posts article:nth-last-child(3):after {
		display: none;
	}
}

@media screen and (max-width: 1680px) {
	.posts article {
		width: calc(50% - 6em);
	}

	.posts article:nth-last-child(3) {
		margin-bottom: 6em;
	}
}

@media screen and (min-width: 481px) and (max-width: 1680px) {
	.posts article:nth-child(2n + 1):before {
		display: none;
	}

	.posts article:nth-child(2n + 1):after {
		width: 100%;
	}

	.posts article:nth-last-child(1),
	.posts article:nth-last-child(2) {
		margin-bottom: 0;
	}

	.posts article:nth-last-child(1):before,
	.posts article:nth-last-child(2):before {
		height: 100%;
	}

	.posts article:nth-last-child(1):after,
	.posts article:nth-last-child(2):after {
		display: none;
	}
}

@media screen and (max-width: 736px) {
	.posts {
		margin: 0 0 2em -4.5em;
		width: calc(100% + 4.5em);
	}

	.posts article {
		margin: 0 0 4.5em 4.5em;
		width: calc(50% - 4.5em);
	}

	.posts article:before {
		height: calc(100% + 4.5em);
		left: -2.25em;
	}

	.posts article:after {
		bottom: -2.25em;
		width: calc(100% + 4.5em);
	}

	.posts article:nth-last-child(3) {
		margin-bottom: 4.5em;
	}
}

@media screen and (max-width: 480px) {
	.posts {
		margin: 0 0 2em 0;
		width: 100%;
	}

	.posts article {
		margin: 0 0 4.5em 0;
		width: 100%;
	}

	.posts article:before {
		display: none;
	}

	.posts article:after {
		width: 100%;
	}

	.posts article:last-child {
		margin-bottom: 0;
	}

	.posts article:last-child:after {
		display: none;
	}
}

/* Wrapper */
#wrapper {
	/* display: -moz-flex; */
	/* display: -webkit-flex; */
	/* display: -ms-flex; */
	/* display: flex; */
	/* -moz-flex-direction: row-reverse; */
	/* -webkit-flex-direction: row-reverse; */
	/* -ms-flex-direction: row-reverse; */
	/* flex-direction: row-reverse; */
	min-height: 100vh;
}

/* Main */
#main {
	/* -moz-flex-grow: 1; */
	/* -webkit-flex-grow: 1; */
	/* -ms-flex-grow: 1; */
	/* flex-grow: 1; */
	/* -moz-flex-shrink: 1; */
	/* -webkit-flex-shrink: 1; */
	/* -ms-flex-shrink: 1; */
	/* flex-shrink: 1; */
	width: 100%;
}

#main>.inner,
#footer>.inner {
	padding: 0 6em 0.1em 6em;
	margin: 0 auto;
	max-width: 110em;
}

#main>.inner>section {
	padding: 6em 0 4em 0;
	border-top: solid 2px rgba(210, 215, 217, 0.75);
}

#main>.inner>section:first-of-type {
	border-top: 0 !important;
}

@media screen and (max-width: 1680px) {

	#main>.inner,
	#footer>.inner {
		padding: 0 5em 0.1em 5em;
	}

	#main>.inner>section {
		padding: 5em 0 3em 0;
	}
}

@media screen and (max-width: 1280px) {

	#main>.inner,
	#footer>.inner {
		padding: 0 4em 0.1em 4em;
	}

	#main>.inner>section {
		padding: 4em 0 2em 0;
	}
}

@media screen and (max-width: 736px) {

	#main>.inner,
	#footer>.inner {
		padding: 0 2em 0.1em 2em;
	}

	#main>.inner>section {
		padding: 3em 0 1em 0;
	}
}

/* Header */
#header {
	display: -moz-flex;
	display: -ms-flex;
	display: flex;
	border-bottom: solid 5px #a8a9ad;
	padding: 0;
	position: relative;
}

#header>* {
	-moz-flex: 1;
	flex: 1 1;
	margin-bottom: 0;
}

#header .logo {
	border-bottom: 0;
	color: inherit;
	font-family: "Roboto Slab", serif;
	font-size: 1.125em;
}

#header .icons {
	text-align: right;
}

@media screen and (max-width: 736px) {
	#header .logo {
		font-size: 1.25em;
		margin: 0;
	}

	#header .icons {
		height: 5em;
		line-height: 5em;
		position: absolute;
		right: -0.5em;
		top: 0;
	}
}

/* Banner */
#banner {
	padding: 6em 0 4em 0;
	display: -moz-flex;
	display: -ms-flex;
	display: flex;
}

#banner h1 {
	margin-top: -0.125em;
}

#banner .content {
	-moz-flex-grow: 1;
	-ms-flex-grow: 1;
	flex-grow: 1;
	-ms-flex-shrink: 1;
	flex-shrink: 1;
	width: 50%;
}

#banner .image {
	-moz-flex-grow: 0;
	-ms-flex-grow: 0;
	flex-grow: 0;
	-ms-flex-shrink: 0;
	flex-shrink: 0;
	display: block;
	margin: 0 0 2em 4em;
	width: 50%;
}

#banner .image img {
	height: 100%;
	-moz-object-fit: cover;
	-webkit-object-fit: cover;
	-ms-object-fit: cover;
	object-fit: cover;
	-moz-object-position: center;
	-webkit-object-position: center;
	-ms-object-position: center;
	object-position: center;
	width: 100%;
}

@media screen and (orientation: portrait) {
	#banner {
		-moz-flex-direction: column-reverse;
		flex-direction: column-reverse;
	}

	#banner h1 br {
		display: none;
	}

	#banner .content {
		-moz-flex-grow: 0;
		-ms-flex-grow: 0;
		flex-grow: 0;
		-ms-flex-shrink: 0;
		flex-shrink: 0;
		width: 100%;
	}

	#banner .image {
		-moz-flex-grow: 0;
		-ms-flex-grow: 0;
		flex-grow: 0;
		-ms-flex-shrink: 0;
		flex-shrink: 0;
		margin: 0 0 4em 0;
		height: 25em;
		max-height: 50vh;
		min-height: 18em;
		width: 100%;
	}
}

@media screen and (orientation: portrait) and (max-width: 480px) {
	#banner .image {
		max-height: 35vh;
	}
}

/* Footer */
#footer {
	background: #f9fafa;
	margin-top: 2em;
	border-top: solid 2px rgba(210, 215, 217, 0.75);
}

#footer .copyright {
	color: #9fa3a6;
	font-size: 0.9em;
}

#footer .copyright a {
	color: inherit;
}

#footer h3 {
	margin-top: 2em;
}

/* Menu */
#menu ul {
	-webkit-user-select: none;
	user-select: none;
	color: #3d4449;
	font-family: "Roboto Slab", serif;
	font-weight: 400;
	letter-spacing: 0.075em;
	list-style: none;
	margin-bottom: 0;
	padding: 0;
	text-transform: uppercase;
}

#menu ul a,
#menu ul span {
	border-bottom: 0;
	color: inherit;
	cursor: pointer;
	display: block;
	font-size: 0.9em;
	padding: 0.625em 0;
}

#menu ul a:hover,
#menu ul span:hover {
	color: #f56a6a;
}

#menu ul a.opener,
#menu ul span.opener {
	transition: color 0.2s ease-in-out;
	text-decoration: none;
	-webkit-tap-highlight-color: rgba(255, 255, 255, 0);
	position: relative;
}

#menu ul a.opener:before,
#menu ul span.opener:before {
	-moz-osx-font-smoothing: grayscale;
	-webkit-font-smoothing: antialiased;
	display: inline-block;
	font-style: normal;
	font-variant: normal;
	text-rendering: auto;
	line-height: 1;
	text-transform: none !important;
	font-family: 'Font Awesome 5 Free';
	font-weight: 900;
}

#menu ul a.opener:before,
#menu ul span.opener:before {
	transition: color 0.2s ease-in-out, transform 0.2s ease-in-out;
	color: #9fa3a6;
	content: '\\f078';
	position: absolute;
	right: 0;
}

#menu ul a.opener:hover:before,
#menu ul span.opener:hover:before {
	color: #f56a6a;
}

#menu ul a.opener.active+ul,
#menu ul span.opener.active+ul {
	display: block;
}

#menu ul a.opener.active:before,
#menu ul span.opener.active:before {
	transform: rotate(-180deg);
}

#menu>ul>li {
	border-top: solid 1px rgba(210, 215, 217, 0.75);
	margin: 0.5em 0 0 0;
	padding: 0.5em 0 0 0;
}

#menu>ul>li>ul {
	color: #9fa3a6;
	display: none;
	margin: 0.5em 0 1.5em 0;
	padding-left: 1em;
}

#menu>ul>li>ul a,
#menu>ul>li>ul span {
	font-size: 0.8em;
}

#menu>ul>li>ul>li {
	margin: 0.125em 0 0 0;
	padding: 0.125em 0 0 0;
}

#menu>ul>li:first-child {
	border-top: 0;
	margin-top: 0;
	padding-top: 0;
}

#logo {
	display: flex;
	padding: 2em !important;
	margin: -1.66667em -1.66667em 3.33333em -1.66667em !important;
	background-color: #eff1f2 !important;
	position: static;
}

#logo img {
	margin: auto;
}

.categorias {
	text-align: center;
	margin-bottom: 3em;
}

.blocosSistemas {
	padding-bottom: 15px;
	background-color: whitesmoke;
	padding-top: 15px;
	color: black;
	margin-bottom: 2.5em !important;
	text-decoration: none;
}

.riscado {
	text-decoration: line-through;
	color: #666666 !important;
}

td.caixa,
th.caixa {
	width: 1em;
	text-align: center;
}

td.caixa label,
th.caixa label {
	padding-right: 0 !important;
}

.contato {
	display: flex;
}

.contato>div {
	flex: 1 1;
	text-indent: -1.8em;
	padding-left: 3em;
}

.contato>div>svg {
	margin-right: 5px;
}

.margem-antes {
	margin: 2em 0 0 0;
}

.botaoIcone {
	margin: 0 !important;
}

td {
	vertical-align: middle;
}

button {
	outline: none !important;
}

.pad0 {
	padding: 0 !important;
}

.botao {
	width: 10px;
}

.botao-voltar {
	margin-right: 1em;
}

span.botao {
	border: 1px solid #7f888f;
	border-radius: 4px;
	padding: 0 10px;
	color: #000000;
}


#mensagem,
.envio-mensagem {
	/*padding: 40px;*/
	text-align: justify;
	font-size: 14pt;
	color: #000000;
	font-family: Roboto, RobotoDraft, Helvetica, Arial, sans-serif;
}

.envio-mensagem p {
	margin: 0;
}

#assinatura,
.envio-assinatura {
	padding: 20 0 100 0px;
	text-align: center;
	font-size: 14pt;
	color: #000000;
	font-family: Roboto, RobotoDraft, Helvetica, Arial, sans-serif;
}

.envio-assinatura p {
	margin: 0;
}

#versao {
	position: fixed;
	top: 0;
	right: 0;
}

.MuiPaper-root {
	padding: 0em !important;
	margin-bottom: 1em;
}

.MuiPaper-root div.cabecalho {
	background-color: lightgray;
	padding: 5px 5px 5px 10px;
	font-weight: 600;
}

.MuiPaper-root label {
	padding: 15px 15px 15px 15px;
	margin: 0;
}

.MuiPaper-root select,
.MuiPaper-root input,
.MuiPaper-root textarea {
	margin: 0 15px 15px 15px;
}

.MuiPaper-root input[type="checkbox"] {
	margin: 0;
}

.MuiTabPanel-root {
	padding: 24px 0 0 0 !important;
}

.MuiButton-root {
	margin-top: 5px;
}

@keyframes spinner {
	0% {
		transform: rotate(0deg);
	}

	100% {
		transform: rotate(360deg);
	}
}

.loading-spinner {
	width: 15px;
	height: 15px;
	border: 5px solid #f3f3f3;
	/* Light grey */
	border-top: 5px solid #ffa500;
	/* Black */
	border-radius: 50%;
	animation: spinner 1.5s linear infinite;
	float: left;
}
.situacao {
	color: orange;
	width: fit-content;
	font-weight: 600;
	float: left;
	margin-left: 8px;
}

.MuiCollapse-root {
	margin-right: 15px;
    margin-top: 10px;
}
.css-ki1hdl-MuiAlert-action {
	margin-right: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,qHAAqH;;AAGrH;;;;CAIC;AACD;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAiFC,SAAS;CACT,UAAU;CACV,eAAe;CACf,eAAe;CACf,aAAa;CACb,wBAAwB;AACzB;;AAEA;;;;;;;;;;;CAWC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;;CAEC,gBAAgB;AACjB;;AAEA;;CAEC,YAAY;AACb;;AAEA;;;;CAIC,WAAW;CACX,aAAa;AACd;;AAEA;CACC,yBAAyB;CACzB,iBAAiB;AAClB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,UAAU;;AAKV;CACC,6BAA6B;AAC9B;;AAEA;;CAEC;;EAEC,gBAAgB;CACjB;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA;;;CAGC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA,SAAS;AACT;;;;CAIC,cAAc;CACd,iCAAiC;CACjC,eAAe;CACf,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC;;;;EAIC,eAAe;CAChB;AACD;;AAEA;CACC;;;;EAIC,eAAe;CAChB;AACD;;AAEA;CACC;;;;EAIC,cAAc;CACf;AACD;;AAEA;CAIC,wEAAwE;CACxE,qBAAqB;AACtB;;AAEA;;CAEC,cAAc;CACd,gBAAgB;AACjB;;AAEA;;CAEC,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;;;;;;CAMC,cAAc;CACd,iCAAiC;CACjC,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;;;;;;CAMC,cAAc;CACd,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC;EACC,gBAAgB;CACjB;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,gBAAgB;EAChB,gBAAgB;CACjB;;CAEA;EACC,gBAAgB;CACjB;AACD;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,gDAAgD;CAChD,kBAAkB;CAClB,iBAAiB;CACjB,0BAA0B;AAC3B;;AAEA;CACC,qCAAqC;CACrC,sBAAsB;CACtB,2CAA2C;CAC3C,qCAAqC;CACrC,gBAAgB;CAChB,gBAAgB;CAChB,sBAAsB;AACvB;;AAEA;CACC,iCAAiC;CACjC,qCAAqC;CACrC,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,cAAc;CACd,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,SAAS;CACT,kDAAkD;CAClD,aAAa;AACd;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,gBAAgB;AACjB;;AAEA,QAAQ;AACR;CACC,aAAa;CACb,eAAe;CACf,sBAAsB;CACtB,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,aAAa;CACb,oBAAoB;AACrB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,oBAAoB;AACrB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC;EACC,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,oBAAoB;CACrB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,2BAA2B;CAC5B;;CAEA;EACC,uBAAuB;CACxB;;CAEA;EACC,yBAAyB;CAC1B;;CAEA;EACC,uBAAuB;CACxB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC,SAAS;CACV;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,WAAW;CACZ;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,aAAa;EACb,gBAAgB;CACjB;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,aAAa;EACb,qBAAqB;CACtB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,oBAAoB;CACrB;;CAEA;EACC,oBAAoB;CACrB;;CAEA;EACC,aAAa;EACb,oBAAoB;CACrB;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,aAAa;EACb,kBAAkB;EAClB,iBAAiB;CAClB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,aAAa;EACb,oBAAoB;CACrB;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,aAAa;EACb,iBAAiB;CAClB;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,gBAAgB;CACjB;AACD;;AAEA;CACC;EACC,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,oBAAoB;CACrB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,2BAA2B;CAC5B;;CAEA;EACC,uBAAuB;CACxB;;CAEA;EACC,yBAAyB;CAC1B;;CAEA;EACC,uBAAuB;CACxB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC,SAAS;CACV;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,WAAW;CACZ;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,aAAa;EACb,gBAAgB;CACjB;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,aAAa;EACb,qBAAqB;CACtB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,oBAAoB;CACrB;;CAEA;EACC,oBAAoB;CACrB;;CAEA;EACC,aAAa;EACb,oBAAoB;CACrB;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,aAAa;EACb,mBAAmB;CACpB;;CAEA;EACC,oBAAoB;CACrB;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,aAAa;EACb,oBAAoB;CACrB;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,aAAa;EACb,iBAAiB;CAClB;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,gBAAgB;CACjB;AACD;;AAEA;CACC;EACC,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,oBAAoB;CACrB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,2BAA2B;CAC5B;;CAEA;EACC,uBAAuB;CACxB;;CAEA;EACC,yBAAyB;CAC1B;;CAEA;EACC,uBAAuB;CACxB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC,SAAS;CACV;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,WAAW;CACZ;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,aAAa;EACb,gBAAgB;CACjB;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,aAAa;EACb,qBAAqB;CACtB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,oBAAoB;CACrB;;CAEA;EACC,oBAAoB;CACrB;;CAEA;EACC,aAAa;EACb,oBAAoB;CACrB;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,aAAa;EACb,mBAAmB;CACpB;;CAEA;EACC,oBAAoB;CACrB;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,aAAa;EACb,oBAAoB;CACrB;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,aAAa;EACb,iBAAiB;CAClB;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,gBAAgB;CACjB;AACD;;AAEA;CACC;EACC,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,oBAAoB;CACrB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,2BAA2B;CAC5B;;CAEA;EACC,uBAAuB;CACxB;;CAEA;EACC,yBAAyB;CAC1B;;CAEA;EACC,uBAAuB;CACxB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC,SAAS;CACV;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,WAAW;CACZ;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,aAAa;EACb,gBAAgB;CACjB;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,aAAa;EACb,qBAAqB;CACtB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,oBAAoB;CACrB;;CAEA;EACC,oBAAoB;CACrB;;CAEA;EACC,aAAa;EACb,oBAAoB;CACrB;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,aAAa;EACb,mBAAmB;CACpB;;CAEA;EACC,oBAAoB;CACrB;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,aAAa;EACb,oBAAoB;CACrB;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,aAAa;EACb,iBAAiB;CAClB;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,gBAAgB;CACjB;AACD;;AAEA;CACC;EACC,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,oBAAoB;CACrB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,2BAA2B;CAC5B;;CAEA;EACC,uBAAuB;CACxB;;CAEA;EACC,yBAAyB;CAC1B;;CAEA;EACC,uBAAuB;CACxB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC,SAAS;CACV;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,WAAW;CACZ;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,aAAa;EACb,gBAAgB;CACjB;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,aAAa;EACb,qBAAqB;CACtB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,oBAAoB;CACrB;;CAEA;EACC,oBAAoB;CACrB;;CAEA;EACC,aAAa;EACb,oBAAoB;CACrB;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,aAAa;EACb,mBAAmB;CACpB;;CAEA;EACC,oBAAoB;CACrB;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,aAAa;EACb,oBAAoB;CACrB;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,aAAa;EACb,iBAAiB;CAClB;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,gBAAgB;CACjB;AACD;;AAEA,oBAAoB;AACpB;;CAEC,kBAAkB;AACnB;;AAEA;CACC,iCAAiC;CACjC,cAAc;CACd,gBAAgB;CAChB,uBAAuB;CACvB,kBAAkB;CAClB,yBAAyB;AAC1B;;AAEA;CACC,gCAAgC;CAChC,qBAAqB;CACrB,iBAAiB;CACjB,yBAAyB;AAC1B;;AAEA;CACC,iBAAiB;AAClB;;AAEA,SAAS;AACT;CACC,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,cAAc;CACd,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;;;;;;;;CAWC,gBAAgB;CAChB,mBAAmB;CACnB,sBAAsB;CACtB,YAAY;CACZ,2CAA2C;CAC3C,cAAc;CACd,cAAc;CACd,UAAU;CACV,cAAc;CACd,qBAAqB;CACrB,6BAA6B;AAC9B;;AAEA;;;;;;;;CAQC,gBAAgB;AACjB;;AAEA;;;;;;;;CAQC,qBAAqB;CACrB,6BAA6B;AAC9B;;AAEA;CACC,yDAA+gB;CAC/gB,uBAAuB;CACvB,4BAA4B;CAC5B,4CAA4C;CAC5C,cAAc;CACd,qBAAqB;CACrB,uBAAuB;AACxB;;AAEA;CACC,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,aAAa;AACd;;AAEA;;;;;;;CAOC,cAAc;AACf;;AAEA;CACC,mBAAmB;AACpB;;AAEA;;CAKC,gBAAgB;CAChB,cAAc;CACd,WAAW;CACX,kBAAkB;CAClB,UAAU;CACV,UAAU;CACV,WAAW;AACZ;;AAEA;;CAEC,qBAAqB;CACrB,cAAc;CACd,eAAe;CACf,qBAAqB;CACrB,cAAc;CACd,gBAAgB;CAChB,mBAAmB;CACnB,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;;CAEC,kCAAkC;CAClC,mCAAmC;CACnC,qBAAqB;CACrB,kBAAkB;CAClB,oBAAoB;CACpB,oBAAoB;CACpB,cAAc;CACd,+BAA+B;CAC/B,kCAAkC;CAClC,gBAAgB;AACjB;;AAEA;;CAEC,mBAAmB;CACnB,sBAAsB;CACtB,2CAA2C;CAC3C,WAAW;CACX,qBAAqB;CACrB,gBAAgB;CAChB,gBAAgB;CAChB,OAAO;CACP,qBAAqB;CACrB,kBAAkB;CAClB,kBAAkB;CAClB,MAAM;CACN,eAAe;AAChB;;AAEA;;CAEC,mBAAmB;CACnB,qBAAqB;CACrB,cAAc;CACd,YAAY;AACb;;AAEA;;CAEC,qBAAqB;CACrB,6BAA6B;AAC9B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,YAAY;AACb;;AAEA;CACC,yBAAyB;CACzB,YAAY;AACb;;AAEA;CACC,yBAAyB;CACzB,YAAY;AACb;;AAEA;CACC,yBAAyB;CACzB,YAAY;AACb;;AAEA,QAAQ;AACR;CACC,sBAAsB;CACtB,2CAA2C;CAC3C,kBAAkB;CAClB,cAAc;AACf;;AAEA;;;CAGC,gBAAgB;AACjB;;AAEA;CACC,SAAS;CACT,gBAAgB;CAChB,UAAU;AACX;;AAEA,SAAS;AACT;CACC,qBAAqB;CACrB,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,kCAAkC;CAClC,mCAAmC;CACnC,qBAAqB;CACrB,kBAAkB;CAClB,oBAAoB;CACpB,oBAAoB;CACpB,cAAc;CACd,+BAA+B;CAC/B,kCAAkC;CAClC,gBAAgB;AACjB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,oCAAoC;AACrC;;AAEA,UAAU;AACV;CACC,sBAAsB;CACtB,SAAS;CACT,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,sBAAsB;CACtB,cAAc;AACf;;AAEA;;CAEC,cAAc;AACf;;AAEA;;CAEC,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,sBAAsB;CACtB,WAAW;AACZ;;AAEA;CACC,YAAY;CACZ,sBAAsB;CACtB,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,iBAAiB;CACjB,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,iBAAiB;CACjB,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CAIC,+BAA+B;AAChC;;AAEA;CAIC,uBAAuB;AACxB;;AAEA,SAAS;AACT;CACC,mBAAmB;CACnB,iBAAiB;CACjB,oBAAoB;AACrB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,+CAA+C;CAC/C,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,cAAc;AACf;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,YAAY;AACZ;CACC,kBAAkB;CAElB,iBAAiB;CACjB,aAAa;CACb,eAAe;CACf,gBAAgB;CAChB,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,sBAAsB;AACvB;;AAEA;CACC,4BAA4B;CAE5B,2BAA2B;CAC3B,uBAAuB;CACvB,WAAW;CACX,cAAc;AACf;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,2BAA2B;CAG3B,sBAAsB;CACtB,cAAc;AACf;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,iBAAiB;CAEjB,gBAAgB;CAChB,YAAY;CAGZ,kBAAkB;CAClB,cAAc;CACd,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA,UAAU;AACV;CACC,eAAe;CACf,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,iBAAiB;AAClB;;AAEA,YAAY;AACZ;CACC,gBAAgB;CAChB,UAAU;AACX;;AAEA;CACC,qBAAqB;CACrB,+CAA+C;CAC/C,mBAAmB;CACnB,sBAAsB;CACtB,kBAAkB;AACnB;;AAEA;CACC,kCAAkC;CAClC,mCAAmC;CACnC,qBAAqB;CACrB,kBAAkB;CAClB,oBAAoB;CACpB,oBAAoB;CACpB,cAAc;CACd,+BAA+B;CAC/B,kCAAkC;CAClC,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,qBAAqB;CACrB,gBAAgB;CAChB,eAAe;CACf,OAAO;CACP,oBAAoB;CACpB,kBAAkB;CAClB,kBAAkB;CAClB,QAAQ;CACR,YAAY;AACb;;AAEA;CACC,aAAa;CACb,aAAa;CACb,cAAc;AACf;;AAEA;CACC,MAAM;AACP;;AAEA;CACC,cAAc;AACf;;AAEA,eAAe;AACf;CACC,eAAe;CACf,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,sBAAsB;AACvB;;AAEA;CAIC,qEAAqE;CACrE,gBAAgB;CAChB,sBAAsB;CACtB,qBAAqB;CACrB,gBAAgB;CAChB,gBAAgB;CAChB,WAAW;CACX,gBAAgB;CAChB,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC;EACC,aAAa;CACd;;CAEA;EACC,gBAAgB;CACjB;AACD;;AAEA,UAAU;AACV;CACC,iCAAiC;CACjC,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;CACjB,WAAW;AACZ;;AAEA;CACC,2CAA2C;CAC3C,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,2CAA2C;AAC5C;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,gBAAgB;CAChB,+BAA+B;CAC/B,gBAAgB;AACjB;;AAEA;CACC,kDAAkD;AACnD;;AAEA;CACC,+CAA+C;AAChD;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,2CAA2C;CAC3C,oBAAoB;CACpB,mBAAmB;AACpB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;AACd;;AAEA,aAAa;AACb;CACC,kBAAkB;CAElB,iBAAiB;CACjB,aAAa;CAIb,eAAe;CACf,oBAAoB;CACpB,uBAAuB;AACxB;;AAEA;CACC,wBAAwB;CAExB,uBAAuB;CACvB,mBAAmB;CACnB,kBAAkB;CAElB,iBAAiB;CACjB,aAAa;CACb,mBAAmB;CACnB,kBAAkB;CAClB,sBAAsB;AACvB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;;CAEC,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;CAEjB,gBAAgB;CAChB,YAAY;CAGZ,kBAAkB;CAClB,cAAc;CACd,cAAc;CACd,YAAY;CACZ,iBAAiB;CACjB,iBAAiB;CACjB,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CAIC,wBAAwB;CACxB,sBAAsB;CACtB,2CAA2C;CAC3C,WAAW;CACX,cAAc;CACd,WAAW;CACX,SAAS;CACT,yBAAyB;CACzB,kBAAkB;CAClB,QAAQ;CACR,UAAU;AACX;;AAEA;CACC,iBAAiB;CAEjB,gBAAgB;CAChB,YAAY;CAGZ,kBAAkB;CAClB,cAAc;CACd,WAAW;AACZ;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC;EACC,iBAAiB;EACjB,WAAW;CACZ;;CAEA;EACC,iBAAiB;EACjB,WAAW;CACZ;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,cAAc;CACf;;CAEA;;EAEC,kBAAkB;CACnB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;EAChB,UAAU;CACX;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,qBAAqB;EACrB,UAAU;CACX;AACD;;AAEA;CACC;EACC,2BAA2B;EAG3B,sBAAsB;EACtB,iCAAiC;EAEjC,+BAA+B;EAC/B,uBAAuB;CACxB;;CAEA;EACC,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;CACX;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,WAAW;EACX,qBAAqB;EACrB,UAAU;CACX;AACD;;AAEA;CACC;EACC,kBAAkB;CACnB;AACD;;AAEA,UAAU;AACV;CACC,kBAAkB;CAElB,iBAAiB;CACjB,aAAa;CAIb,eAAe;CACf,0BAA0B;CAC1B,6BAA6B;AAC9B;;AAEA;CACC,iBAAiB;CAEjB,gBAAgB;CAChB,YAAY;CAGZ,kBAAkB;CAClB,cAAc;CACd,mBAAmB;CACnB,kBAAkB;CAClB,4BAA4B;AAC7B;;AAEA;CACC,qCAAqC;CACrC,WAAW;CACX,cAAc;CACd,wBAAwB;CACxB,UAAU;CACV,kBAAkB;CAClB,MAAM;CACN,UAAU;AACX;;AAEA;CACC,qCAAqC;CACrC,YAAY;CACZ,WAAW;CACX,cAAc;CACd,WAAW;CACX,kBAAkB;CAClB,QAAQ;CACR,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,iBAAiB;AAClB;;AAEA;CACC,cAAc;CACd,WAAW;AACZ;;AAEA;CACC;EACC,aAAa;CACd;;CAEA;EACC,WAAW;CACZ;;CAEA;;;EAGC,gBAAgB;CACjB;;CAEA;;;EAGC,YAAY;CACb;;CAEA;;;EAGC,aAAa;CACd;AACD;;AAEA;CACC;EACC,sBAAsB;CACvB;;CAEA;EACC,kBAAkB;CACnB;AACD;;AAEA;CACC;EACC,aAAa;CACd;;CAEA;EACC,WAAW;CACZ;;CAEA;;EAEC,gBAAgB;CACjB;;CAEA;;EAEC,YAAY;CACb;;CAEA;;EAEC,aAAa;CACd;AACD;;AAEA;CACC;EACC,sBAAsB;EACtB,yBAAyB;CAC1B;;CAEA;EACC,uBAAuB;EACvB,wBAAwB;CACzB;;CAEA;EACC,0BAA0B;EAC1B,aAAa;CACd;;CAEA;EACC,eAAe;EACf,yBAAyB;CAC1B;;CAEA;EACC,oBAAoB;CACrB;AACD;;AAEA;CACC;EACC,iBAAiB;EACjB,WAAW;CACZ;;CAEA;EACC,mBAAmB;EACnB,WAAW;CACZ;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,WAAW;CACZ;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,aAAa;CACd;AACD;;AAEA,YAAY;AACZ;CACC,wBAAwB;CACxB,2BAA2B;CAC3B,uBAAuB;CACvB,mBAAmB;CACnB,sCAAsC;CACtC,yCAAyC;CACzC,qCAAqC;CACrC,iCAAiC;CACjC,iBAAiB;AAClB;;AAEA,SAAS;AACT;CACC,uBAAuB;CACvB,0BAA0B;CAC1B,sBAAsB;CACtB,kBAAkB;CAClB,yBAAyB;CACzB,4BAA4B;CAC5B,wBAAwB;CACxB,oBAAoB;CACpB,WAAW;AACZ;;AAEA;;CAEC,wBAAwB;CACxB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;CACpB,+CAA+C;AAChD;;AAEA;CACC,wBAAwB;AACzB;;AAEA;;CAEC;;EAEC,wBAAwB;CACzB;;CAEA;EACC,oBAAoB;CACrB;AACD;;AAEA;;CAEC;;EAEC,wBAAwB;CACzB;;CAEA;EACC,oBAAoB;CACrB;AACD;;AAEA;;CAEC;;EAEC,wBAAwB;CACzB;;CAEA;EACC,oBAAoB;CACrB;AACD;;AAEA,WAAW;AACX;CACC,kBAAkB;CAElB,iBAAiB;CACjB,aAAa;CACb,gCAAgC;CAChC,UAAU;CACV,kBAAkB;AACnB;;AAEA;CACC,YAAY;CAGZ,SAAO;CACP,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,cAAc;CACd,iCAAiC;CACjC,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC;EACC,iBAAiB;EACjB,SAAS;CACV;;CAEA;EACC,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,MAAM;CACP;AACD;;AAEA,WAAW;AACX;CACC,oBAAoB;CACpB,kBAAkB;CAElB,iBAAiB;CACjB,aAAa;AACd;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,iBAAiB;CAEjB,gBAAgB;CAChB,YAAY;CAGZ,kBAAkB;CAClB,cAAc;CACd,UAAU;AACX;;AAEA;CACC,iBAAiB;CAEjB,gBAAgB;CAChB,YAAY;CAGZ,kBAAkB;CAClB,cAAc;CACd,cAAc;CACd,mBAAmB;CACnB,UAAU;AACX;;AAEA;CACC,YAAY;CACZ,sBAAsB;CACtB,yBAAyB;CACzB,qBAAqB;CACrB,iBAAiB;CACjB,4BAA4B;CAC5B,+BAA+B;CAC/B,2BAA2B;CAC3B,uBAAuB;CACvB,WAAW;AACZ;;AAEA;CACC;EACC,mCAAmC;EAGnC,8BAA8B;CAC/B;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,iBAAiB;EAEjB,gBAAgB;EAChB,YAAY;EAGZ,kBAAkB;EAClB,cAAc;EACd,WAAW;CACZ;;CAEA;EACC,iBAAiB;EAEjB,gBAAgB;EAChB,YAAY;EAGZ,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;CACZ;AACD;;AAEA;CACC;EACC,gBAAgB;CACjB;AACD;;AAEA,WAAW;AACX;CACC,mBAAmB;CACnB,eAAe;CACf,+CAA+C;AAChD;;AAEA;CACC,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,eAAe;AAChB;;AAEA,SAAS;AACT;CAEC,yBAAyB;CAEzB,iBAAiB;CACjB,cAAc;CACd,iCAAiC;CACjC,gBAAgB;CAChB,uBAAuB;CACvB,gBAAgB;CAChB,gBAAgB;CAChB,UAAU;CACV,yBAAyB;AAC1B;;AAEA;;CAEC,gBAAgB;CAChB,cAAc;CACd,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;;CAEC,cAAc;AACf;;AAEA;;CAKC,kCAAkC;CAClC,qBAAqB;CACrB,mDAAmD;CACnD,kBAAkB;AACnB;;AAEA;;CAEC,kCAAkC;CAClC,mCAAmC;CACnC,qBAAqB;CACrB,kBAAkB;CAClB,oBAAoB;CACpB,oBAAoB;CACpB,cAAc;CACd,+BAA+B;CAC/B,kCAAkC;CAClC,gBAAgB;AACjB;;AAEA;;CAKC,8DAA8D;CAC9D,cAAc;CACd,gBAAgB;CAChB,kBAAkB;CAClB,QAAQ;AACT;;AAEA;;CAEC,cAAc;AACf;;AAEA;;CAEC,cAAc;AACf;;AAEA;;CAKC,0BAA0B;AAC3B;;AAEA;CACC,+CAA+C;CAC/C,mBAAmB;CACnB,oBAAoB;AACrB;;AAEA;CACC,cAAc;CACd,aAAa;CACb,uBAAuB;CACvB,iBAAiB;AAClB;;AAEA;;CAEC,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;CACrB,sBAAsB;AACvB;;AAEA;CACC,aAAa;CACb,aAAa;CACb,cAAc;AACf;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,6DAA6D;CAC7D,oCAAoC;CACpC,gBAAgB;AACjB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,oBAAoB;CACpB,4BAA4B;CAC5B,iBAAiB;CACjB,YAAY;CACZ,+BAA+B;CAC/B,qBAAqB;AACtB;;AAEA;CACC,6BAA6B;CAC7B,yBAAyB;AAC1B;;AAEA;;CAEC,UAAU;CACV,kBAAkB;AACnB;;AAEA;;CAEC,2BAA2B;AAC5B;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,SAAO;CACP,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,yBAAyB;CACzB,kBAAkB;CAClB,eAAe;CACf,cAAc;AACf;;;AAGA;;CAEC,iBAAiB;CACjB,mBAAmB;CACnB,eAAe;CACf,cAAc;CACd,8DAA8D;AAC/D;;AAEA;CACC,SAAS;AACV;;AAEA;;CAEC,qBAAqB;CACrB,kBAAkB;CAClB,eAAe;CACf,cAAc;CACd,8DAA8D;AAC/D;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,eAAe;CACf,MAAM;CACN,QAAQ;AACT;;AAEA;CACC,uBAAuB;CACvB,kBAAkB;AACnB;;AAEA;CACC,2BAA2B;CAC3B,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,4BAA4B;CAC5B,SAAS;AACV;;AAEA;;;CAGC,wBAAwB;AACzB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC;EACC,uBAAuB;CACxB;;CAEA;EACC,yBAAyB;CAC1B;AACD;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,UAAU;CACV,kBAAkB;CAClB,uCAAuC;CACvC,WAAW;AACZ;AACA;CACC,aAAa;CACb,kBAAkB;CAClB,gBAAgB;CAChB,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;IACf,gBAAgB;AACpB;AACA;CACC,0BAA0B;AAC3B","sourcesContent":["/*@import url(\"https://fonts.googleapis.com/css?family=Open+Sans:400,600,400italic,600italic|Roboto+Slab:400,700\"); */\n@import url(\"https://fonts.googleapis.com/css?family=Roboto&display=swap\");\n\n/*\n\tEditorial by HTML5 UP\n\thtml5up.net | @ajlkn\n\tFree for personal and commercial use under the CCA 3.0 license (html5up.net/license)\n*/\nhtml,\nbody,\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n\tmargin: 0;\n\tpadding: 0;\n\t/* border: 0; */\n\tfont-size: 100%;\n\tfont: inherit;\n\tvertical-align: baseline;\n}\n\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\nsection {\n\tdisplay: block;\n}\n\nbody {\n\tline-height: 1;\n}\n\nol,\nul {\n\tlist-style: none;\n}\n\nblockquote,\nq {\n\tquotes: none;\n}\n\nblockquote:before,\nblockquote:after,\nq:before,\nq:after {\n\tcontent: '';\n\tcontent: none;\n}\n\ntable {\n\tborder-collapse: collapse;\n\tborder-spacing: 0;\n}\n\nbody {\n\t-webkit-text-size-adjust: none;\n}\n\n/* Basic */\n@-ms-viewport {\n\twidth: device-width;\n}\n\nbody {\n\t-ms-overflow-style: scrollbar;\n}\n\n@media screen and (max-width: 480px) {\n\n\thtml,\n\tbody {\n\t\tmin-width: 320px;\n\t}\n}\n\nhtml {\n\tbox-sizing: border-box;\n}\n\n*,\n*:before,\n*:after {\n\tbox-sizing: inherit;\n}\n\nbody {\n\tbackground: #ffffff;\n}\n\n/* Type */\nbody,\ninput,\nselect,\ntextarea {\n\tcolor: #7f888f;\n\tfont-family: \"Roboto\", sans-serif;\n\tfont-size: 13pt;\n\tfont-weight: 400;\n\tline-height: 1.65;\n}\n\n@media screen and (max-width: 1680px) {\n\tbody,\n\tinput,\n\tselect,\n\ttextarea {\n\t\tfont-size: 11pt;\n\t}\n}\n\n@media screen and (max-width: 1280px) {\n\tbody,\n\tinput,\n\tselect,\n\ttextarea {\n\t\tfont-size: 10pt;\n\t}\n}\n\n@media screen and (max-width: 360px) {\n\tbody,\n\tinput,\n\tselect,\n\ttextarea {\n\t\tfont-size: 9pt;\n\t}\n}\n\na {\n\t-moz-transition: color 0.2s ease-in-out, border-bottom-color 0.2s ease-in-out;\n\t-webkit-transition: color 0.2s ease-in-out, border-bottom-color 0.2s ease-in-out;\n\t-ms-transition: color 0.2s ease-in-out, border-bottom-color 0.2s ease-in-out;\n\ttransition: color 0.2s ease-in-out, border-bottom-color 0.2s ease-in-out;\n\ttext-decoration: none;\n}\n\nstrong,\nb {\n\tcolor: #3d4449;\n\tfont-weight: 600;\n}\n\nem,\ni {\n\tfont-style: italic;\n}\n\np {\n\tmargin: 0 0 2em 0;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n\tcolor: #3d4449;\n\tfont-family: \"Roboto Slab\", serif;\n\tfont-weight: 700;\n\tline-height: 1.5;\n\tmargin: 0 0 1em 0;\n}\n\nh1 a,\nh2 a,\nh3 a,\nh4 a,\nh5 a,\nh6 a {\n\tcolor: inherit;\n\ttext-decoration: none;\n\tborder-bottom: 0;\n}\n\nh1 {\n\tfont-size: 3em;\n\tmargin: 0 0 0.5em 0;\n\tline-height: 1.3;\n}\n\nh2 {\n\tfont-size: 1.75em;\n}\n\nh3 {\n\tfont-size: 1.25em;\n}\n\nh4 {\n\tfont-size: 1.1em;\n}\n\nh5 {\n\tfont-size: 0.9em;\n}\n\nh6 {\n\tfont-size: 0.7em;\n}\n\n@media screen and (max-width: 1680px) {\n\th1 {\n\t\tfont-size: 2.5em;\n\t}\n}\n\n@media screen and (max-width: 980px) {\n\th1 {\n\t\tfont-size: 2em;\n\t}\n}\n\n@media screen and (max-width: 736px) {\n\th1 {\n\t\tfont-size: 1.5em;\n\t\tline-height: 1.4;\n\t}\n\n\th2 {\n\t\tfont-size: 1.5em;\n\t}\n}\n\nsub {\n\tfont-size: 0.8em;\n\tposition: relative;\n\ttop: 0.5em;\n}\n\nsup {\n\tfont-size: 0.8em;\n\tposition: relative;\n\ttop: -0.5em;\n}\n\nblockquote {\n\tborder-left: solid 3px rgba(210, 215, 217, 0.75);\n\tfont-style: italic;\n\tmargin: 0 0 2em 0;\n\tpadding: 0.5em 0 0.5em 2em;\n}\n\ncode {\n\tbackground: rgba(230, 235, 237, 0.25);\n\tborder-radius: 0.375em;\n\tborder: solid 1px rgba(210, 215, 217, 0.75);\n\tfont-family: \"Courier New\", monospace;\n\tfont-size: 0.9em;\n\tmargin: 0 0.25em;\n\tpadding: 0.25em 0.65em;\n}\n\npre {\n\t-webkit-overflow-scrolling: touch;\n\tfont-family: \"Courier New\", monospace;\n\tfont-size: 0.9em;\n\tmargin: 0 0 2em 0;\n}\n\npre code {\n\tdisplay: block;\n\tline-height: 1.75;\n\tpadding: 1em 1.5em;\n\toverflow-x: auto;\n}\n\nhr {\n\tborder: 0;\n\tborder-bottom: solid 1px rgba(210, 215, 217, 0.75);\n\tmargin: 2em 0;\n}\n\nhr.major {\n\tmargin: 3em 0;\n}\n\n.align-left {\n\ttext-align: left !important;\n}\n\n.align-center {\n\ttext-align: center !important;\n}\n\n.align-right {\n\tmargin-left: 78%;\n}\n\n/* Row */\n.row {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tbox-sizing: border-box;\n\talign-items: stretch;\n}\n\n.row>* {\n\tbox-sizing: border-box;\n}\n\n.row.gtr-uniform>*> :last-child {\n\tmargin-bottom: 0;\n}\n\n.row.aln-left {\n\tjustify-content: flex-start;\n}\n\n.row.aln-center {\n\tjustify-content: center;\n}\n\n.row.aln-right {\n\tjustify-content: flex-end;\n}\n\n.row.aln-top {\n\talign-items: flex-start;\n}\n\n.row.aln-middle {\n\talign-items: center;\n}\n\n.row.aln-bottom {\n\talign-items: flex-end;\n}\n\n.row>.imp {\n\torder: -1;\n}\n\n.row>.col-1 {\n\twidth: 8.33333%;\n}\n\n.row>.off-1 {\n\tmargin-left: 8.33333%;\n}\n\n.row>.col-2 {\n\twidth: 16.66667%;\n}\n\n.row>.off-2 {\n\tmargin-left: 16.66667%;\n}\n\n.row>.col-3 {\n\twidth: 25%;\n}\n\n.row>.off-3 {\n\tmargin-left: 25%;\n}\n\n.row>.col-4 {\n\twidth: 33.33333%;\n}\n\n.row>.off-4 {\n\tmargin-left: 33.33333%;\n}\n\n.row>.col-5 {\n\twidth: 41.66667%;\n}\n\n.row>.off-5 {\n\tmargin-left: 41.66667%;\n}\n\n.row>.col-6 {\n\twidth: 50%;\n}\n\n.row>.off-6 {\n\tmargin-left: 50%;\n}\n\n.row>.col-7 {\n\twidth: 58.33333%;\n}\n\n.row>.off-7 {\n\tmargin-left: 58.33333%;\n}\n\n.row>.col-8 {\n\twidth: 66.66667%;\n}\n\n.row>.off-8 {\n\tmargin-left: 66.66667%;\n}\n\n.row>.col-9 {\n\twidth: 75%;\n}\n\n.row>.off-9 {\n\tmargin-left: 75%;\n}\n\n.row>.col-10 {\n\twidth: 83.33333%;\n}\n\n.row>.off-10 {\n\tmargin-left: 83.33333%;\n}\n\n.row>.col-11 {\n\twidth: 91.66667%;\n}\n\n.row>.off-11 {\n\tmargin-left: 91.66667%;\n}\n\n.row>.col-12 {\n\twidth: 100%;\n}\n\n.row>.off-12 {\n\tmargin-left: 100%;\n}\n\n.row.gtr-0 {\n\tmargin-top: 0;\n\tmargin-left: 0em;\n}\n\n.row.gtr-0>* {\n\tpadding: 0 0 0 0em;\n}\n\n.row.gtr-0.gtr-uniform {\n\tmargin-top: 0em;\n}\n\n.row.gtr-0.gtr-uniform>* {\n\tpadding-top: 0em;\n}\n\n.row.gtr-25 {\n\tmargin-top: 0;\n\tmargin-left: -0.375em;\n}\n\n.row.gtr-25>* {\n\tpadding: 0 0 0 0.375em;\n}\n\n.row.gtr-25.gtr-uniform {\n\tmargin-top: -0.375em;\n}\n\n.row.gtr-25.gtr-uniform>* {\n\tpadding-top: 0.375em;\n}\n\n.row.gtr-50 {\n\tmargin-top: 0;\n\tmargin-left: -0.75em;\n}\n\n.row.gtr-50>* {\n\tpadding: 0 0 0 0.75em;\n}\n\n.row.gtr-50.gtr-uniform {\n\tmargin-top: -0.75em;\n}\n\n.row.gtr-50.gtr-uniform>* {\n\tpadding-top: 0.75em;\n}\n\n.row {\n\tmargin-top: 0;\n\tmargin-left: -1.5em;\n}\n\n.row>* {\n\tpadding: 0 0 0 1.5em;\n}\n\n.row.gtr-uniform {\n\tmargin-top: -1.5em;\n}\n\n.row.gtr-uniform>* {\n\tpadding-top: 1.5em;\n}\n\n.row.gtr-150 {\n\tmargin-top: 0;\n\tmargin-left: -2.25em;\n}\n\n.row.gtr-150>* {\n\tpadding: 0 0 0 2.25em;\n}\n\n.row.gtr-150.gtr-uniform {\n\tmargin-top: -2.25em;\n}\n\n.row.gtr-150.gtr-uniform>* {\n\tpadding-top: 2.25em;\n}\n\n.row.gtr-200 {\n\tmargin-top: 0;\n\tmargin-left: -3em;\n}\n\n.row.gtr-200>* {\n\tpadding: 0 0 0 3em;\n}\n\n.row.gtr-200.gtr-uniform {\n\tmargin-top: -3em;\n}\n\n.row.gtr-200.gtr-uniform>* {\n\tpadding-top: 3em;\n}\n\n@media screen and (max-width: 1680px) {\n\t.row {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\tbox-sizing: border-box;\n\t\talign-items: stretch;\n\t}\n\n\t.row>* {\n\t\tbox-sizing: border-box;\n\t}\n\n\t.row.gtr-uniform>*> :last-child {\n\t\tmargin-bottom: 0;\n\t}\n\n\t.row.aln-left {\n\t\tjustify-content: flex-start;\n\t}\n\n\t.row.aln-center {\n\t\tjustify-content: center;\n\t}\n\n\t.row.aln-right {\n\t\tjustify-content: flex-end;\n\t}\n\n\t.row.aln-top {\n\t\talign-items: flex-start;\n\t}\n\n\t.row.aln-middle {\n\t\talign-items: center;\n\t}\n\n\t.row.aln-bottom {\n\t\talign-items: flex-end;\n\t}\n\n\t.row>.imp-xlarge {\n\t\torder: -1;\n\t}\n\n\t.row>.col-1-xlarge {\n\t\twidth: 8.33333%;\n\t}\n\n\t.row>.off-1-xlarge {\n\t\tmargin-left: 8.33333%;\n\t}\n\n\t.row>.col-2-xlarge {\n\t\twidth: 16.66667%;\n\t}\n\n\t.row>.off-2-xlarge {\n\t\tmargin-left: 16.66667%;\n\t}\n\n\t.row>.col-3-xlarge {\n\t\twidth: 25%;\n\t}\n\n\t.row>.off-3-xlarge {\n\t\tmargin-left: 25%;\n\t}\n\n\t.row>.col-4-xlarge {\n\t\twidth: 33.33333%;\n\t}\n\n\t.row>.off-4-xlarge {\n\t\tmargin-left: 33.33333%;\n\t}\n\n\t.row>.col-5-xlarge {\n\t\twidth: 41.66667%;\n\t}\n\n\t.row>.off-5-xlarge {\n\t\tmargin-left: 41.66667%;\n\t}\n\n\t.row>.col-6-xlarge {\n\t\twidth: 50%;\n\t}\n\n\t.row>.off-6-xlarge {\n\t\tmargin-left: 50%;\n\t}\n\n\t.row>.col-7-xlarge {\n\t\twidth: 58.33333%;\n\t}\n\n\t.row>.off-7-xlarge {\n\t\tmargin-left: 58.33333%;\n\t}\n\n\t.row>.col-8-xlarge {\n\t\twidth: 66.66667%;\n\t}\n\n\t.row>.off-8-xlarge {\n\t\tmargin-left: 66.66667%;\n\t}\n\n\t.row>.col-9-xlarge {\n\t\twidth: 75%;\n\t}\n\n\t.row>.off-9-xlarge {\n\t\tmargin-left: 75%;\n\t}\n\n\t.row>.col-10-xlarge {\n\t\twidth: 83.33333%;\n\t}\n\n\t.row>.off-10-xlarge {\n\t\tmargin-left: 83.33333%;\n\t}\n\n\t.row>.col-11-xlarge {\n\t\twidth: 91.66667%;\n\t}\n\n\t.row>.off-11-xlarge {\n\t\tmargin-left: 91.66667%;\n\t}\n\n\t.row>.col-12-xlarge {\n\t\twidth: 100%;\n\t}\n\n\t.row>.off-12-xlarge {\n\t\tmargin-left: 100%;\n\t}\n\n\t.row.gtr-0 {\n\t\tmargin-top: 0;\n\t\tmargin-left: 0em;\n\t}\n\n\t.row.gtr-0>* {\n\t\tpadding: 0 0 0 0em;\n\t}\n\n\t.row.gtr-0.gtr-uniform {\n\t\tmargin-top: 0em;\n\t}\n\n\t.row.gtr-0.gtr-uniform>* {\n\t\tpadding-top: 0em;\n\t}\n\n\t.row.gtr-25 {\n\t\tmargin-top: 0;\n\t\tmargin-left: -0.375em;\n\t}\n\n\t.row.gtr-25>* {\n\t\tpadding: 0 0 0 0.375em;\n\t}\n\n\t.row.gtr-25.gtr-uniform {\n\t\tmargin-top: -0.375em;\n\t}\n\n\t.row.gtr-25.gtr-uniform>* {\n\t\tpadding-top: 0.375em;\n\t}\n\n\t.row.gtr-50 {\n\t\tmargin-top: 0;\n\t\tmargin-left: -0.75em;\n\t}\n\n\t.row.gtr-50>* {\n\t\tpadding: 0 0 0 0.75em;\n\t}\n\n\t.row.gtr-50.gtr-uniform {\n\t\tmargin-top: -0.75em;\n\t}\n\n\t.row.gtr-50.gtr-uniform>* {\n\t\tpadding-top: 0.75em;\n\t}\n\n\t.row {\n\t\tmargin-top: 0;\n\t\tmargin-left: -15px;\n\t\tmargin-right: 1px;\n\t}\n\n\t.row>* {\n\t\tpadding: 0 0 0 15px;\n\t}\n\n\t.row.gtr-uniform {\n\t\tmargin-top: -1.5em;\n\t}\n\n\t.row.gtr-uniform>* {\n\t\tpadding-top: 1.5em;\n\t}\n\n\t.row.gtr-150 {\n\t\tmargin-top: 0;\n\t\tmargin-left: -2.25em;\n\t}\n\n\t.row.gtr-150>* {\n\t\tpadding: 0 0 0 2.25em;\n\t}\n\n\t.row.gtr-150.gtr-uniform {\n\t\tmargin-top: -2.25em;\n\t}\n\n\t.row.gtr-150.gtr-uniform>* {\n\t\tpadding-top: 2.25em;\n\t}\n\n\t.row.gtr-200 {\n\t\tmargin-top: 0;\n\t\tmargin-left: -3em;\n\t}\n\n\t.row.gtr-200>* {\n\t\tpadding: 0 0 0 3em;\n\t}\n\n\t.row.gtr-200.gtr-uniform {\n\t\tmargin-top: -3em;\n\t}\n\n\t.row.gtr-200.gtr-uniform>* {\n\t\tpadding-top: 3em;\n\t}\n}\n\n@media screen and (max-width: 1280px) {\n\t.row {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\tbox-sizing: border-box;\n\t\talign-items: stretch;\n\t}\n\n\t.row>* {\n\t\tbox-sizing: border-box;\n\t}\n\n\t.row.gtr-uniform>*> :last-child {\n\t\tmargin-bottom: 0;\n\t}\n\n\t.row.aln-left {\n\t\tjustify-content: flex-start;\n\t}\n\n\t.row.aln-center {\n\t\tjustify-content: center;\n\t}\n\n\t.row.aln-right {\n\t\tjustify-content: flex-end;\n\t}\n\n\t.row.aln-top {\n\t\talign-items: flex-start;\n\t}\n\n\t.row.aln-middle {\n\t\talign-items: center;\n\t}\n\n\t.row.aln-bottom {\n\t\talign-items: flex-end;\n\t}\n\n\t.row>.imp-large {\n\t\torder: -1;\n\t}\n\n\t.row>.col-1-large {\n\t\twidth: 8.33333%;\n\t}\n\n\t.row>.off-1-large {\n\t\tmargin-left: 8.33333%;\n\t}\n\n\t.row>.col-2-large {\n\t\twidth: 16.66667%;\n\t}\n\n\t.row>.off-2-large {\n\t\tmargin-left: 16.66667%;\n\t}\n\n\t.row>.col-3-large {\n\t\twidth: 25%;\n\t}\n\n\t.row>.off-3-large {\n\t\tmargin-left: 25%;\n\t}\n\n\t.row>.col-4-large {\n\t\twidth: 33.33333%;\n\t}\n\n\t.row>.off-4-large {\n\t\tmargin-left: 33.33333%;\n\t}\n\n\t.row>.col-5-large {\n\t\twidth: 41.66667%;\n\t}\n\n\t.row>.off-5-large {\n\t\tmargin-left: 41.66667%;\n\t}\n\n\t.row>.col-6-large {\n\t\twidth: 50%;\n\t}\n\n\t.row>.off-6-large {\n\t\tmargin-left: 50%;\n\t}\n\n\t.row>.col-7-large {\n\t\twidth: 58.33333%;\n\t}\n\n\t.row>.off-7-large {\n\t\tmargin-left: 58.33333%;\n\t}\n\n\t.row>.col-8-large {\n\t\twidth: 66.66667%;\n\t}\n\n\t.row>.off-8-large {\n\t\tmargin-left: 66.66667%;\n\t}\n\n\t.row>.col-9-large {\n\t\twidth: 75%;\n\t}\n\n\t.row>.off-9-large {\n\t\tmargin-left: 75%;\n\t}\n\n\t.row>.col-10-large {\n\t\twidth: 83.33333%;\n\t}\n\n\t.row>.off-10-large {\n\t\tmargin-left: 83.33333%;\n\t}\n\n\t.row>.col-11-large {\n\t\twidth: 91.66667%;\n\t}\n\n\t.row>.off-11-large {\n\t\tmargin-left: 91.66667%;\n\t}\n\n\t.row>.col-12-large {\n\t\twidth: 100%;\n\t}\n\n\t.row>.off-12-large {\n\t\tmargin-left: 100%;\n\t}\n\n\t.row.gtr-0 {\n\t\tmargin-top: 0;\n\t\tmargin-left: 0em;\n\t}\n\n\t.row.gtr-0>* {\n\t\tpadding: 0 0 0 0em;\n\t}\n\n\t.row.gtr-0.gtr-uniform {\n\t\tmargin-top: 0em;\n\t}\n\n\t.row.gtr-0.gtr-uniform>* {\n\t\tpadding-top: 0em;\n\t}\n\n\t.row.gtr-25 {\n\t\tmargin-top: 0;\n\t\tmargin-left: -0.375em;\n\t}\n\n\t.row.gtr-25>* {\n\t\tpadding: 0 0 0 0.375em;\n\t}\n\n\t.row.gtr-25.gtr-uniform {\n\t\tmargin-top: -0.375em;\n\t}\n\n\t.row.gtr-25.gtr-uniform>* {\n\t\tpadding-top: 0.375em;\n\t}\n\n\t.row.gtr-50 {\n\t\tmargin-top: 0;\n\t\tmargin-left: -0.75em;\n\t}\n\n\t.row.gtr-50>* {\n\t\tpadding: 0 0 0 0.75em;\n\t}\n\n\t.row.gtr-50.gtr-uniform {\n\t\tmargin-top: -0.75em;\n\t}\n\n\t.row.gtr-50.gtr-uniform>* {\n\t\tpadding-top: 0.75em;\n\t}\n\n\t.row {\n\t\tmargin-top: 0;\n\t\tmargin-left: -1.5em;\n\t}\n\n\t.row>* {\n\t\tpadding: 0 0 0 1.5em;\n\t}\n\n\t.row.gtr-uniform {\n\t\tmargin-top: -1.5em;\n\t}\n\n\t.row.gtr-uniform>* {\n\t\tpadding-top: 1.5em;\n\t}\n\n\t.row.gtr-150 {\n\t\tmargin-top: 0;\n\t\tmargin-left: -2.25em;\n\t}\n\n\t.row.gtr-150>* {\n\t\tpadding: 0 0 0 2.25em;\n\t}\n\n\t.row.gtr-150.gtr-uniform {\n\t\tmargin-top: -2.25em;\n\t}\n\n\t.row.gtr-150.gtr-uniform>* {\n\t\tpadding-top: 2.25em;\n\t}\n\n\t.row.gtr-200 {\n\t\tmargin-top: 0;\n\t\tmargin-left: -3em;\n\t}\n\n\t.row.gtr-200>* {\n\t\tpadding: 0 0 0 3em;\n\t}\n\n\t.row.gtr-200.gtr-uniform {\n\t\tmargin-top: -3em;\n\t}\n\n\t.row.gtr-200.gtr-uniform>* {\n\t\tpadding-top: 3em;\n\t}\n}\n\n@media screen and (max-width: 980px) {\n\t.row {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\tbox-sizing: border-box;\n\t\talign-items: stretch;\n\t}\n\n\t.row>* {\n\t\tbox-sizing: border-box;\n\t}\n\n\t.row.gtr-uniform>*> :last-child {\n\t\tmargin-bottom: 0;\n\t}\n\n\t.row.aln-left {\n\t\tjustify-content: flex-start;\n\t}\n\n\t.row.aln-center {\n\t\tjustify-content: center;\n\t}\n\n\t.row.aln-right {\n\t\tjustify-content: flex-end;\n\t}\n\n\t.row.aln-top {\n\t\talign-items: flex-start;\n\t}\n\n\t.row.aln-middle {\n\t\talign-items: center;\n\t}\n\n\t.row.aln-bottom {\n\t\talign-items: flex-end;\n\t}\n\n\t.row>.imp-medium {\n\t\torder: -1;\n\t}\n\n\t.row>.col-1-medium {\n\t\twidth: 8.33333%;\n\t}\n\n\t.row>.off-1-medium {\n\t\tmargin-left: 8.33333%;\n\t}\n\n\t.row>.col-2-medium {\n\t\twidth: 16.66667%;\n\t}\n\n\t.row>.off-2-medium {\n\t\tmargin-left: 16.66667%;\n\t}\n\n\t.row>.col-3-medium {\n\t\twidth: 25%;\n\t}\n\n\t.row>.off-3-medium {\n\t\tmargin-left: 25%;\n\t}\n\n\t.row>.col-4-medium {\n\t\twidth: 33.33333%;\n\t}\n\n\t.row>.off-4-medium {\n\t\tmargin-left: 33.33333%;\n\t}\n\n\t.row>.col-5-medium {\n\t\twidth: 41.66667%;\n\t}\n\n\t.row>.off-5-medium {\n\t\tmargin-left: 41.66667%;\n\t}\n\n\t.row>.col-6-medium {\n\t\twidth: 50%;\n\t}\n\n\t.row>.off-6-medium {\n\t\tmargin-left: 50%;\n\t}\n\n\t.row>.col-7-medium {\n\t\twidth: 58.33333%;\n\t}\n\n\t.row>.off-7-medium {\n\t\tmargin-left: 58.33333%;\n\t}\n\n\t.row>.col-8-medium {\n\t\twidth: 66.66667%;\n\t}\n\n\t.row>.off-8-medium {\n\t\tmargin-left: 66.66667%;\n\t}\n\n\t.row>.col-9-medium {\n\t\twidth: 75%;\n\t}\n\n\t.row>.off-9-medium {\n\t\tmargin-left: 75%;\n\t}\n\n\t.row>.col-10-medium {\n\t\twidth: 83.33333%;\n\t}\n\n\t.row>.off-10-medium {\n\t\tmargin-left: 83.33333%;\n\t}\n\n\t.row>.col-11-medium {\n\t\twidth: 91.66667%;\n\t}\n\n\t.row>.off-11-medium {\n\t\tmargin-left: 91.66667%;\n\t}\n\n\t.row>.col-12-medium {\n\t\twidth: 100%;\n\t}\n\n\t.row>.off-12-medium {\n\t\tmargin-left: 100%;\n\t}\n\n\t.row.gtr-0 {\n\t\tmargin-top: 0;\n\t\tmargin-left: 0em;\n\t}\n\n\t.row.gtr-0>* {\n\t\tpadding: 0 0 0 0em;\n\t}\n\n\t.row.gtr-0.gtr-uniform {\n\t\tmargin-top: 0em;\n\t}\n\n\t.row.gtr-0.gtr-uniform>* {\n\t\tpadding-top: 0em;\n\t}\n\n\t.row.gtr-25 {\n\t\tmargin-top: 0;\n\t\tmargin-left: -0.375em;\n\t}\n\n\t.row.gtr-25>* {\n\t\tpadding: 0 0 0 0.375em;\n\t}\n\n\t.row.gtr-25.gtr-uniform {\n\t\tmargin-top: -0.375em;\n\t}\n\n\t.row.gtr-25.gtr-uniform>* {\n\t\tpadding-top: 0.375em;\n\t}\n\n\t.row.gtr-50 {\n\t\tmargin-top: 0;\n\t\tmargin-left: -0.75em;\n\t}\n\n\t.row.gtr-50>* {\n\t\tpadding: 0 0 0 0.75em;\n\t}\n\n\t.row.gtr-50.gtr-uniform {\n\t\tmargin-top: -0.75em;\n\t}\n\n\t.row.gtr-50.gtr-uniform>* {\n\t\tpadding-top: 0.75em;\n\t}\n\n\t.row {\n\t\tmargin-top: 0;\n\t\tmargin-left: -1.5em;\n\t}\n\n\t.row>* {\n\t\tpadding: 0 0 0 1.5em;\n\t}\n\n\t.row.gtr-uniform {\n\t\tmargin-top: -1.5em;\n\t}\n\n\t.row.gtr-uniform>* {\n\t\tpadding-top: 1.5em;\n\t}\n\n\t.row.gtr-150 {\n\t\tmargin-top: 0;\n\t\tmargin-left: -2.25em;\n\t}\n\n\t.row.gtr-150>* {\n\t\tpadding: 0 0 0 2.25em;\n\t}\n\n\t.row.gtr-150.gtr-uniform {\n\t\tmargin-top: -2.25em;\n\t}\n\n\t.row.gtr-150.gtr-uniform>* {\n\t\tpadding-top: 2.25em;\n\t}\n\n\t.row.gtr-200 {\n\t\tmargin-top: 0;\n\t\tmargin-left: -3em;\n\t}\n\n\t.row.gtr-200>* {\n\t\tpadding: 0 0 0 3em;\n\t}\n\n\t.row.gtr-200.gtr-uniform {\n\t\tmargin-top: -3em;\n\t}\n\n\t.row.gtr-200.gtr-uniform>* {\n\t\tpadding-top: 3em;\n\t}\n}\n\n@media screen and (max-width: 736px) {\n\t.row {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\tbox-sizing: border-box;\n\t\talign-items: stretch;\n\t}\n\n\t.row>* {\n\t\tbox-sizing: border-box;\n\t}\n\n\t.row.gtr-uniform>*> :last-child {\n\t\tmargin-bottom: 0;\n\t}\n\n\t.row.aln-left {\n\t\tjustify-content: flex-start;\n\t}\n\n\t.row.aln-center {\n\t\tjustify-content: center;\n\t}\n\n\t.row.aln-right {\n\t\tjustify-content: flex-end;\n\t}\n\n\t.row.aln-top {\n\t\talign-items: flex-start;\n\t}\n\n\t.row.aln-middle {\n\t\talign-items: center;\n\t}\n\n\t.row.aln-bottom {\n\t\talign-items: flex-end;\n\t}\n\n\t.row>.imp-small {\n\t\torder: -1;\n\t}\n\n\t.row>.col-1-small {\n\t\twidth: 8.33333%;\n\t}\n\n\t.row>.off-1-small {\n\t\tmargin-left: 8.33333%;\n\t}\n\n\t.row>.col-2-small {\n\t\twidth: 16.66667%;\n\t}\n\n\t.row>.off-2-small {\n\t\tmargin-left: 16.66667%;\n\t}\n\n\t.row>.col-3-small {\n\t\twidth: 25%;\n\t}\n\n\t.row>.off-3-small {\n\t\tmargin-left: 25%;\n\t}\n\n\t.row>.col-4-small {\n\t\twidth: 33.33333%;\n\t}\n\n\t.row>.off-4-small {\n\t\tmargin-left: 33.33333%;\n\t}\n\n\t.row>.col-5-small {\n\t\twidth: 41.66667%;\n\t}\n\n\t.row>.off-5-small {\n\t\tmargin-left: 41.66667%;\n\t}\n\n\t.row>.col-6-small {\n\t\twidth: 50%;\n\t}\n\n\t.row>.off-6-small {\n\t\tmargin-left: 50%;\n\t}\n\n\t.row>.col-7-small {\n\t\twidth: 58.33333%;\n\t}\n\n\t.row>.off-7-small {\n\t\tmargin-left: 58.33333%;\n\t}\n\n\t.row>.col-8-small {\n\t\twidth: 66.66667%;\n\t}\n\n\t.row>.off-8-small {\n\t\tmargin-left: 66.66667%;\n\t}\n\n\t.row>.col-9-small {\n\t\twidth: 75%;\n\t}\n\n\t.row>.off-9-small {\n\t\tmargin-left: 75%;\n\t}\n\n\t.row>.col-10-small {\n\t\twidth: 83.33333%;\n\t}\n\n\t.row>.off-10-small {\n\t\tmargin-left: 83.33333%;\n\t}\n\n\t.row>.col-11-small {\n\t\twidth: 91.66667%;\n\t}\n\n\t.row>.off-11-small {\n\t\tmargin-left: 91.66667%;\n\t}\n\n\t.row>.col-12-small {\n\t\twidth: 100%;\n\t}\n\n\t.row>.off-12-small {\n\t\tmargin-left: 100%;\n\t}\n\n\t.row.gtr-0 {\n\t\tmargin-top: 0;\n\t\tmargin-left: 0em;\n\t}\n\n\t.row.gtr-0>* {\n\t\tpadding: 0 0 0 0em;\n\t}\n\n\t.row.gtr-0.gtr-uniform {\n\t\tmargin-top: 0em;\n\t}\n\n\t.row.gtr-0.gtr-uniform>* {\n\t\tpadding-top: 0em;\n\t}\n\n\t.row.gtr-25 {\n\t\tmargin-top: 0;\n\t\tmargin-left: -0.375em;\n\t}\n\n\t.row.gtr-25>* {\n\t\tpadding: 0 0 0 0.375em;\n\t}\n\n\t.row.gtr-25.gtr-uniform {\n\t\tmargin-top: -0.375em;\n\t}\n\n\t.row.gtr-25.gtr-uniform>* {\n\t\tpadding-top: 0.375em;\n\t}\n\n\t.row.gtr-50 {\n\t\tmargin-top: 0;\n\t\tmargin-left: -0.75em;\n\t}\n\n\t.row.gtr-50>* {\n\t\tpadding: 0 0 0 0.75em;\n\t}\n\n\t.row.gtr-50.gtr-uniform {\n\t\tmargin-top: -0.75em;\n\t}\n\n\t.row.gtr-50.gtr-uniform>* {\n\t\tpadding-top: 0.75em;\n\t}\n\n\t.row {\n\t\tmargin-top: 0;\n\t\tmargin-left: -1.5em;\n\t}\n\n\t.row>* {\n\t\tpadding: 0 0 0 1.5em;\n\t}\n\n\t.row.gtr-uniform {\n\t\tmargin-top: -1.5em;\n\t}\n\n\t.row.gtr-uniform>* {\n\t\tpadding-top: 1.5em;\n\t}\n\n\t.row.gtr-150 {\n\t\tmargin-top: 0;\n\t\tmargin-left: -2.25em;\n\t}\n\n\t.row.gtr-150>* {\n\t\tpadding: 0 0 0 2.25em;\n\t}\n\n\t.row.gtr-150.gtr-uniform {\n\t\tmargin-top: -2.25em;\n\t}\n\n\t.row.gtr-150.gtr-uniform>* {\n\t\tpadding-top: 2.25em;\n\t}\n\n\t.row.gtr-200 {\n\t\tmargin-top: 0;\n\t\tmargin-left: -3em;\n\t}\n\n\t.row.gtr-200>* {\n\t\tpadding: 0 0 0 3em;\n\t}\n\n\t.row.gtr-200.gtr-uniform {\n\t\tmargin-top: -3em;\n\t}\n\n\t.row.gtr-200.gtr-uniform>* {\n\t\tpadding-top: 3em;\n\t}\n}\n\n@media screen and (max-width: 480px) {\n\t.row {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\tbox-sizing: border-box;\n\t\talign-items: stretch;\n\t}\n\n\t.row>* {\n\t\tbox-sizing: border-box;\n\t}\n\n\t.row.gtr-uniform>*> :last-child {\n\t\tmargin-bottom: 0;\n\t}\n\n\t.row.aln-left {\n\t\tjustify-content: flex-start;\n\t}\n\n\t.row.aln-center {\n\t\tjustify-content: center;\n\t}\n\n\t.row.aln-right {\n\t\tjustify-content: flex-end;\n\t}\n\n\t.row.aln-top {\n\t\talign-items: flex-start;\n\t}\n\n\t.row.aln-middle {\n\t\talign-items: center;\n\t}\n\n\t.row.aln-bottom {\n\t\talign-items: flex-end;\n\t}\n\n\t.row>.imp-xsmall {\n\t\torder: -1;\n\t}\n\n\t.row>.col-1-xsmall {\n\t\twidth: 8.33333%;\n\t}\n\n\t.row>.off-1-xsmall {\n\t\tmargin-left: 8.33333%;\n\t}\n\n\t.row>.col-2-xsmall {\n\t\twidth: 16.66667%;\n\t}\n\n\t.row>.off-2-xsmall {\n\t\tmargin-left: 16.66667%;\n\t}\n\n\t.row>.col-3-xsmall {\n\t\twidth: 25%;\n\t}\n\n\t.row>.off-3-xsmall {\n\t\tmargin-left: 25%;\n\t}\n\n\t.row>.col-4-xsmall {\n\t\twidth: 33.33333%;\n\t}\n\n\t.row>.off-4-xsmall {\n\t\tmargin-left: 33.33333%;\n\t}\n\n\t.row>.col-5-xsmall {\n\t\twidth: 41.66667%;\n\t}\n\n\t.row>.off-5-xsmall {\n\t\tmargin-left: 41.66667%;\n\t}\n\n\t.row>.col-6-xsmall {\n\t\twidth: 50%;\n\t}\n\n\t.row>.off-6-xsmall {\n\t\tmargin-left: 50%;\n\t}\n\n\t.row>.col-7-xsmall {\n\t\twidth: 58.33333%;\n\t}\n\n\t.row>.off-7-xsmall {\n\t\tmargin-left: 58.33333%;\n\t}\n\n\t.row>.col-8-xsmall {\n\t\twidth: 66.66667%;\n\t}\n\n\t.row>.off-8-xsmall {\n\t\tmargin-left: 66.66667%;\n\t}\n\n\t.row>.col-9-xsmall {\n\t\twidth: 75%;\n\t}\n\n\t.row>.off-9-xsmall {\n\t\tmargin-left: 75%;\n\t}\n\n\t.row>.col-10-xsmall {\n\t\twidth: 83.33333%;\n\t}\n\n\t.row>.off-10-xsmall {\n\t\tmargin-left: 83.33333%;\n\t}\n\n\t.row>.col-11-xsmall {\n\t\twidth: 91.66667%;\n\t}\n\n\t.row>.off-11-xsmall {\n\t\tmargin-left: 91.66667%;\n\t}\n\n\t.row>.col-12-xsmall {\n\t\twidth: 100%;\n\t}\n\n\t.row>.off-12-xsmall {\n\t\tmargin-left: 100%;\n\t}\n\n\t.row.gtr-0 {\n\t\tmargin-top: 0;\n\t\tmargin-left: 0em;\n\t}\n\n\t.row.gtr-0>* {\n\t\tpadding: 0 0 0 0em;\n\t}\n\n\t.row.gtr-0.gtr-uniform {\n\t\tmargin-top: 0em;\n\t}\n\n\t.row.gtr-0.gtr-uniform>* {\n\t\tpadding-top: 0em;\n\t}\n\n\t.row.gtr-25 {\n\t\tmargin-top: 0;\n\t\tmargin-left: -0.375em;\n\t}\n\n\t.row.gtr-25>* {\n\t\tpadding: 0 0 0 0.375em;\n\t}\n\n\t.row.gtr-25.gtr-uniform {\n\t\tmargin-top: -0.375em;\n\t}\n\n\t.row.gtr-25.gtr-uniform>* {\n\t\tpadding-top: 0.375em;\n\t}\n\n\t.row.gtr-50 {\n\t\tmargin-top: 0;\n\t\tmargin-left: -0.75em;\n\t}\n\n\t.row.gtr-50>* {\n\t\tpadding: 0 0 0 0.75em;\n\t}\n\n\t.row.gtr-50.gtr-uniform {\n\t\tmargin-top: -0.75em;\n\t}\n\n\t.row.gtr-50.gtr-uniform>* {\n\t\tpadding-top: 0.75em;\n\t}\n\n\t.row {\n\t\tmargin-top: 0;\n\t\tmargin-left: -1.5em;\n\t}\n\n\t.row>* {\n\t\tpadding: 0 0 0 1.5em;\n\t}\n\n\t.row.gtr-uniform {\n\t\tmargin-top: -1.5em;\n\t}\n\n\t.row.gtr-uniform>* {\n\t\tpadding-top: 1.5em;\n\t}\n\n\t.row.gtr-150 {\n\t\tmargin-top: 0;\n\t\tmargin-left: -2.25em;\n\t}\n\n\t.row.gtr-150>* {\n\t\tpadding: 0 0 0 2.25em;\n\t}\n\n\t.row.gtr-150.gtr-uniform {\n\t\tmargin-top: -2.25em;\n\t}\n\n\t.row.gtr-150.gtr-uniform>* {\n\t\tpadding-top: 2.25em;\n\t}\n\n\t.row.gtr-200 {\n\t\tmargin-top: 0;\n\t\tmargin-left: -3em;\n\t}\n\n\t.row.gtr-200>* {\n\t\tpadding: 0 0 0 3em;\n\t}\n\n\t.row.gtr-200.gtr-uniform {\n\t\tmargin-top: -3em;\n\t}\n\n\t.row.gtr-200.gtr-uniform>* {\n\t\tpadding-top: 3em;\n\t}\n}\n\n/* Section/Article */\nsection.special,\narticle.special {\n\ttext-align: center;\n}\n\nheader p {\n\tfont-family: \"Roboto Slab\", serif;\n\tfont-size: 1em;\n\tfont-weight: 400;\n\tletter-spacing: 0.075em;\n\tmargin-top: -0.5em;\n\ttext-transform: uppercase;\n}\n\nheader.major> :last-child {\n\tborder-bottom: solid 3px #f56a6a;\n\tdisplay: inline-block;\n\tmargin: 0 0 2em 0;\n\tpadding: 0 0.75em 0.5em 0;\n}\n\nheader.main> :last-child {\n\tmargin: 0 0 1em 0;\n}\n\n/* Form */\nform {\n\tmargin: 2em 0 2em 0;\n}\n\nlabel {\n\tcolor: #3d4449;\n\tdisplay: block;\n\tfont-size: 0.9em;\n\tfont-weight: 600;\n\tmargin: 0 0 1em 0;\n}\n\ninput[type=\"text\"],\ninput[type=\"password\"],\ninput[type=\"email\"],\ninput[type=\"tel\"],\ninput[type=\"search\"],\ninput[type=\"url\"],\nselect,\ntextarea {\n\t-moz-appearance: none;\n\t-webkit-appearance: none;\n\t-ms-appearance: none;\n\tappearance: none;\n\tbackground: #ffffff;\n\tborder-radius: 0.375em;\n\tborder: none;\n\tborder: solid 1px rgba(210, 215, 217, 0.75);\n\tcolor: inherit;\n\tdisplay: block;\n\toutline: 0;\n\tpadding: 0 1em;\n\ttext-decoration: none;\n\twidth: -webkit-fill-available;\n}\n\ninput[type=\"text\"]:invalid,\ninput[type=\"password\"]:invalid,\ninput[type=\"email\"]:invalid,\ninput[type=\"tel\"]:invalid,\ninput[type=\"search\"]:invalid,\ninput[type=\"url\"]:invalid,\nselect:invalid,\ntextarea:invalid {\n\tbox-shadow: none;\n}\n\ninput[type=\"text\"]:focus,\ninput[type=\"password\"]:focus,\ninput[type=\"email\"]:focus,\ninput[type=\"tel\"]:focus,\ninput[type=\"search\"]:focus,\ninput[type=\"url\"]:focus,\nselect:focus,\ntextarea:focus {\n\tborder-color: #f56a6a;\n\tbox-shadow: 0 0 0 1px #f56a6a;\n}\n\nselect {\n\tbackground-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' preserveAspectRatio='none' viewBox='0 0 40 40'%3E%3Cpath d='M9.4,12.3l10.4,10.4l10.4-10.4c0.2-0.2,0.5-0.4,0.9-0.4c0.3,0,0.6,0.1,0.9,0.4l3.3,3.3c0.2,0.2,0.4,0.5,0.4,0.9 c0,0.4-0.1,0.6-0.4,0.9L20.7,31.9c-0.2,0.2-0.5,0.4-0.9,0.4c-0.3,0-0.6-0.1-0.9-0.4L4.3,17.3c-0.2-0.2-0.4-0.5-0.4-0.9 c0-0.4,0.1-0.6,0.4-0.9l3.3-3.3c0.2-0.2,0.5-0.4,0.9-0.4S9.1,12.1,9.4,12.3z' fill='rgba(210, 215, 217, 0.75)' /%3E%3C/svg%3E\");\n\tbackground-size: 1.25em;\n\tbackground-repeat: no-repeat;\n\tbackground-position: calc(100% - 1em) center;\n\theight: 2.75em;\n\tpadding-right: 2.75em;\n\ttext-overflow: ellipsis;\n}\n\nselect option {\n\tcolor: #3d4449;\n\tbackground: #ffffff;\n}\n\nselect:focus::-ms-value {\n\tbackground-color: transparent;\n}\n\nselect::-ms-expand {\n\tdisplay: none;\n}\n\ninput[type=\"text\"],\ninput[type=\"password\"],\ninput[type=\"email\"],\ninput[type=\"tel\"],\ninput[type=\"search\"],\ninput[type=\"url\"],\nselect {\n\theight: 2.75em;\n}\n\ntextarea {\n\tpadding: 0.75em 1em;\n}\n\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n\t-moz-appearance: none;\n\t-webkit-appearance: none;\n\t-ms-appearance: none;\n\tappearance: none;\n\tdisplay: block;\n\tfloat: left;\n\tmargin-right: -2em;\n\topacity: 0;\n\twidth: 1em;\n\tz-index: -1;\n}\n\ninput[type=\"checkbox\"]+label,\ninput[type=\"radio\"]+label {\n\ttext-decoration: none;\n\tcolor: #7f888f;\n\tcursor: pointer;\n\tdisplay: inline-block;\n\tfont-size: 1em;\n\tfont-weight: 400;\n\tpadding-left: 1.5em;\n\tpadding-right: 0.75em;\n\tposition: relative;\n}\n\ninput[type=\"checkbox\"]+label:before,\ninput[type=\"radio\"]+label:before {\n\t-moz-osx-font-smoothing: grayscale;\n\t-webkit-font-smoothing: antialiased;\n\tdisplay: inline-block;\n\tfont-style: normal;\n\tfont-variant: normal;\n\ttext-rendering: auto;\n\tline-height: 1;\n\ttext-transform: none !important;\n\tfont-family: 'Font Awesome 5 Free';\n\tfont-weight: 900;\n}\n\ninput[type=\"checkbox\"]+label:before,\ninput[type=\"radio\"]+label:before {\n\tbackground: #ffffff;\n\tborder-radius: 0.375em;\n\tborder: solid 1px rgba(210, 215, 217, 0.75);\n\tcontent: '';\n\tdisplay: inline-block;\n\tfont-size: 0.8em;\n\theight: 2.0625em;\n\tleft: 0;\n\tline-height: 2.0625em;\n\tposition: absolute;\n\ttext-align: center;\n\ttop: 0;\n\twidth: 2.0625em;\n}\n\ninput[type=\"checkbox\"]:checked+label:before,\ninput[type=\"radio\"]:checked+label:before {\n\tbackground: #3d4449;\n\tborder-color: #3d4449;\n\tcolor: #ffffff;\n\tcontent: 'X';\n}\n\ninput[type=\"checkbox\"]:focus+label:before,\ninput[type=\"radio\"]:focus+label:before {\n\tborder-color: #f56a6a;\n\tbox-shadow: 0 0 0 1px #f56a6a;\n}\n\ninput[type=\"checkbox\"]+label:before {\n\tborder-radius: 0.375em;\n}\n\ninput[type=\"radio\"]+label:before {\n\tborder-radius: 100%;\n}\n\n::-webkit-input-placeholder {\n\tcolor: #9fa3a6 !important;\n\topacity: 1.0;\n}\n\n:-moz-placeholder {\n\tcolor: #9fa3a6 !important;\n\topacity: 1.0;\n}\n\n::-moz-placeholder {\n\tcolor: #9fa3a6 !important;\n\topacity: 1.0;\n}\n\n:-ms-input-placeholder {\n\tcolor: #9fa3a6 !important;\n\topacity: 1.0;\n}\n\n/* Box */\n.box {\n\tborder-radius: 0.375em;\n\tborder: solid 1px rgba(210, 215, 217, 0.75);\n\tmargin-bottom: 2em;\n\tpadding: 1.5em;\n}\n\n.box> :last-child,\n.box> :last-child> :last-child,\n.box> :last-child> :last-child> :last-child {\n\tmargin-bottom: 0;\n}\n\n.box.alt {\n\tborder: 0;\n\tborder-radius: 0;\n\tpadding: 0;\n}\n\n/* Icon */\n.icon {\n\ttext-decoration: none;\n\tborder-bottom: none;\n\tposition: relative;\n}\n\n.icon:before {\n\t-moz-osx-font-smoothing: grayscale;\n\t-webkit-font-smoothing: antialiased;\n\tdisplay: inline-block;\n\tfont-style: normal;\n\tfont-variant: normal;\n\ttext-rendering: auto;\n\tline-height: 1;\n\ttext-transform: none !important;\n\tfont-family: 'Font Awesome 5 Free';\n\tfont-weight: 400;\n}\n\n.icon>.label {\n\tdisplay: none;\n}\n\n.icon:before {\n\tline-height: inherit;\n}\n\n.icon.solid:before {\n\tfont-weight: 900;\n}\n\n.icon.brands:before {\n\tfont-family: 'Font Awesome 5 Brands';\n}\n\n/* Image */\n.image {\n\tborder-radius: 0.375em;\n\tborder: 0;\n\tdisplay: inline-block;\n\tposition: relative;\n}\n\n.image img {\n\tborder-radius: 0.375em;\n\tdisplay: block;\n}\n\n.image.left,\n.image.right {\n\tmax-width: 40%;\n}\n\n.image.left img,\n.image.right img {\n\twidth: 100%;\n}\n\n.image.left {\n\tfloat: left;\n\tpadding: 0 1.5em 1em 0;\n\ttop: 0.25em;\n}\n\n.image.right {\n\tfloat: right;\n\tpadding: 0 0 1em 1.5em;\n\ttop: 0.25em;\n}\n\n.image.fit {\n\tdisplay: block;\n\tmargin: 0 0 2em 0;\n\twidth: 100%;\n}\n\n.image.fit img {\n\twidth: 100%;\n}\n\n.image.main {\n\tdisplay: block;\n\tmargin: 0 0 3em 0;\n\twidth: 100%;\n}\n\n.image.main img {\n\twidth: 100%;\n}\n\na.image {\n\toverflow: hidden;\n}\n\na.image img {\n\t-moz-transition: -moz-transform 0.2s ease;\n\t-webkit-transition: -webkit-transform 0.2s ease;\n\t-ms-transition: -ms-transform 0.2s ease;\n\ttransition: transform 0.2s ease;\n}\n\na.image:hover img {\n\t-moz-transform: scale(1.075);\n\t-webkit-transform: scale(1.075);\n\t-ms-transform: scale(1.075);\n\ttransform: scale(1.075);\n}\n\n/* List */\nol {\n\tlist-style: decimal;\n\tmargin: 0 0 2em 0;\n\tpadding-left: 1.25em;\n}\n\nol li {\n\tpadding-left: 0.25em;\n}\n\nul {\n\tlist-style: disc;\n\tmargin: 0 0 0 0;\n\tpadding-left: 1em;\n}\n\nul li {\n\tpadding-left: 0.5em;\n}\n\nul.alt {\n\tlist-style: none;\n\tpadding-left: 0;\n}\n\nul.alt li {\n\tborder-top: solid 1px rgba(210, 215, 217, 0.75);\n\tpadding: 0.5em 0;\n}\n\nul.alt li:first-child {\n\tborder-top: 0;\n\tpadding-top: 0;\n}\n\ndl {\n\tmargin: 0 0 2em 0;\n}\n\ndl dt {\n\tdisplay: block;\n\tfont-weight: 600;\n\tmargin: 0 0 1em 0;\n}\n\ndl dd {\n\tmargin-left: 2em;\n}\n\n/* Actions */\nul.actions {\n\tdisplay: -moz-flex;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flex;\n\tdisplay: flex;\n\tcursor: default;\n\tlist-style: none;\n\tmargin-left: -1em;\n\tpadding-left: 0;\n}\n\nul.actions li {\n\tpadding: 0 0 0 1em;\n\tvertical-align: middle;\n}\n\nul.actions.special {\n\t-moz-justify-content: center;\n\t-webkit-justify-content: center;\n\t-ms-justify-content: center;\n\tjustify-content: center;\n\twidth: 100%;\n\tmargin-left: 0;\n}\n\nul.actions.special li:first-child {\n\tpadding-left: 0;\n}\n\nul.actions.stacked {\n\t-moz-flex-direction: column;\n\t-webkit-flex-direction: column;\n\t-ms-flex-direction: column;\n\tflex-direction: column;\n\tmargin-left: 0;\n}\n\nul.actions.stacked li {\n\tpadding: 1.3em 0 0 0;\n}\n\nul.actions.stacked li:first-child {\n\tpadding-top: 0;\n}\n\nul.actions.fit {\n\twidth: calc(100% + 1em);\n}\n\nul.actions.fit li {\n\t-moz-flex-grow: 1;\n\t-webkit-flex-grow: 1;\n\t-ms-flex-grow: 1;\n\tflex-grow: 1;\n\t-moz-flex-shrink: 1;\n\t-webkit-flex-shrink: 1;\n\t-ms-flex-shrink: 1;\n\tflex-shrink: 1;\n\twidth: 100%;\n}\n\nul.actions.fit li>* {\n\twidth: 100%;\n}\n\nul.actions.fit.stacked {\n\twidth: 100%;\n}\n\n/* Icons */\nul.icons {\n\tcursor: default;\n\tlist-style: none;\n\tpadding-left: 0;\n}\n\nul.icons li {\n\tdisplay: inline-block;\n\tpadding: 0 1em 0 0;\n}\n\nul.icons li:last-child {\n\tpadding-right: 0;\n}\n\nul.icons li .icon {\n\tcolor: inherit;\n}\n\nul.icons li .icon:before {\n\tfont-size: 1.25em;\n}\n\n/* Contact */\nul.contact {\n\tlist-style: none;\n\tpadding: 0;\n}\n\nul.contact li {\n\ttext-decoration: none;\n\tborder-top: solid 1px rgba(210, 215, 217, 0.75);\n\tmargin: 1.5em 0 0 0;\n\tpadding: 1.5em 0 0 3em;\n\tposition: relative;\n}\n\nul.contact li:before {\n\t-moz-osx-font-smoothing: grayscale;\n\t-webkit-font-smoothing: antialiased;\n\tdisplay: inline-block;\n\tfont-style: normal;\n\tfont-variant: normal;\n\ttext-rendering: auto;\n\tline-height: 1;\n\ttext-transform: none !important;\n\tfont-family: 'Font Awesome 5 Free';\n\tfont-weight: 400;\n}\n\nul.contact li:before {\n\tcolor: #f56a6a;\n\tdisplay: inline-block;\n\tfont-size: 1.5em;\n\theight: 1.125em;\n\tleft: 0;\n\tline-height: 1.125em;\n\tposition: absolute;\n\ttext-align: center;\n\ttop: 1em;\n\twidth: 1.5em;\n}\n\nul.contact li:first-child {\n\tborder-top: 0;\n\tmargin-top: 0;\n\tpadding-top: 0;\n}\n\nul.contact li:first-child:before {\n\ttop: 0;\n}\n\nul.contact li a {\n\tcolor: inherit;\n}\n\n/* Pagination */\nul.pagination {\n\tcursor: default;\n\tlist-style: none;\n\tpadding-left: 0;\n}\n\nul.pagination li {\n\tdisplay: inline-block;\n\tpadding-left: 0;\n\tvertical-align: middle;\n}\n\nul.pagination li>.page {\n\t-moz-transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;\n\t-webkit-transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;\n\t-ms-transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;\n\ttransition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;\n\tborder-bottom: 0;\n\tborder-radius: 0.375em;\n\tdisplay: inline-block;\n\tfont-size: 0.8em;\n\tfont-weight: 600;\n\theight: 2em;\n\tline-height: 2em;\n\tmargin: 0 0.125em;\n\tmin-width: 2em;\n\tpadding: 0 0.5em;\n\ttext-align: center;\n}\n\nul.pagination li>.page.active {\n\tbackground-color: #f56a6a;\n\tcolor: #ffffff !important;\n}\n\nul.pagination li>.page.active:hover {\n\tbackground-color: #f67878;\n}\n\nul.pagination li>.page.active:active {\n\tbackground-color: #f45c5c;\n}\n\nul.pagination li:first-child {\n\tpadding-right: 0.75em;\n}\n\nul.pagination li:last-child {\n\tpadding-left: 0.75em;\n}\n\n@media screen and (max-width: 480px) {\n\tul.pagination li:nth-child(n+2):nth-last-child(n+2) {\n\t\tdisplay: none;\n\t}\n\n\tul.pagination li:first-child {\n\t\tpadding-right: 0;\n\t}\n}\n\n/* Table */\n.table-wrapper {\n\t-webkit-overflow-scrolling: touch;\n\toverflow-x: auto;\n}\n\ntable {\n\tmargin: 0 0 2em 0;\n\twidth: 100%;\n}\n\ntable tbody tr {\n\tborder: solid 1px rgba(210, 215, 217, 0.75);\n\tborder-left: 0;\n\tborder-right: 0;\n}\n\ntable tbody tr:nth-child(2n + 1) {\n\tbackground-color: rgba(230, 235, 237, 0.25);\n}\n\ntable td {\n\tpadding: 0.75em 0.75em;\n}\n\ntable th {\n\tcolor: #3d4449;\n\tfont-size: 0.9em;\n\tfont-weight: 600;\n\tpadding: 0 0.75em 0.75em 0.75em;\n\ttext-align: left;\n}\n\ntable thead {\n\tborder-bottom: solid 2px rgba(210, 215, 217, 0.75);\n}\n\ntable tfoot {\n\tborder-top: solid 2px rgba(210, 215, 217, 0.75);\n}\n\ntable.alt {\n\tborder-collapse: separate;\n}\n\ntable.alt tbody tr td {\n\tborder: solid 1px rgba(210, 215, 217, 0.75);\n\tborder-left-width: 0;\n\tborder-top-width: 0;\n}\n\ntable.alt tbody tr td:first-child {\n\tborder-left-width: 1px;\n}\n\ntable.alt tbody tr:first-child td {\n\tborder-top-width: 1px;\n}\n\ntable.alt thead {\n\tborder-bottom: 0;\n}\n\ntable.alt tfoot {\n\tborder-top: 0;\n}\n\n/* Features */\n.features {\n\tdisplay: -moz-flex;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flex;\n\tdisplay: flex;\n\t-moz-flex-wrap: wrap;\n\t-webkit-flex-wrap: wrap;\n\t-ms-flex-wrap: wrap;\n\tflex-wrap: wrap;\n\tmargin: 0 0 2em -3em;\n\twidth: calc(100% + 3em);\n}\n\n.features article {\n\t-moz-align-items: center;\n\t-webkit-align-items: center;\n\t-ms-align-items: center;\n\talign-items: center;\n\tdisplay: -moz-flex;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flex;\n\tdisplay: flex;\n\tmargin: 0 0 3em 3em;\n\tposition: relative;\n\twidth: calc(50% - 3em);\n}\n\n.features article:nth-child(2n - 1) {\n\tmargin-right: 1.5em;\n}\n\n.features article:nth-child(2n) {\n\tmargin-left: 1.5em;\n}\n\n.features article:nth-last-child(1),\n.features article:nth-last-child(2) {\n\tmargin-bottom: 0;\n}\n\n.features article .icon {\n\t-moz-flex-grow: 0;\n\t-webkit-flex-grow: 0;\n\t-ms-flex-grow: 0;\n\tflex-grow: 0;\n\t-moz-flex-shrink: 0;\n\t-webkit-flex-shrink: 0;\n\t-ms-flex-shrink: 0;\n\tflex-shrink: 0;\n\tdisplay: block;\n\theight: 10em;\n\tline-height: 10em;\n\tmargin: 0 2em 0 0;\n\ttext-align: center;\n\twidth: 10em;\n}\n\n.features article .icon:before {\n\tcolor: #f56a6a;\n\tfont-size: 2.75rem;\n\tposition: relative;\n\ttop: 0.05em;\n}\n\n.features article .icon:after {\n\t-moz-transform: rotate(45deg);\n\t-webkit-transform: rotate(45deg);\n\t-ms-transform: rotate(45deg);\n\ttransform: rotate(45deg);\n\tborder-radius: 0.25rem;\n\tborder: solid 2px rgba(210, 215, 217, 0.75);\n\tcontent: '';\n\tdisplay: block;\n\theight: 7em;\n\tleft: 50%;\n\tmargin: -3.5em 0 0 -3.5em;\n\tposition: absolute;\n\ttop: 50%;\n\twidth: 7em;\n}\n\n.features article .content {\n\t-moz-flex-grow: 1;\n\t-webkit-flex-grow: 1;\n\t-ms-flex-grow: 1;\n\tflex-grow: 1;\n\t-moz-flex-shrink: 1;\n\t-webkit-flex-shrink: 1;\n\t-ms-flex-shrink: 1;\n\tflex-shrink: 1;\n\twidth: 100%;\n}\n\n.features article .content> :last-child {\n\tmargin-bottom: 0;\n}\n\n@media screen and (max-width: 980px) {\n\t.features {\n\t\tmargin: 0 0 2em 0;\n\t\twidth: 100%;\n\t}\n\n\t.features article {\n\t\tmargin: 0 0 3em 0;\n\t\twidth: 100%;\n\t}\n\n\t.features article:nth-child(2n - 1) {\n\t\tmargin-right: 0;\n\t}\n\n\t.features article:nth-child(2n) {\n\t\tmargin-left: 0;\n\t}\n\n\t.features article:nth-last-child(1),\n\t.features article:nth-last-child(2) {\n\t\tmargin-bottom: 3em;\n\t}\n\n\t.features article:last-child {\n\t\tmargin-bottom: 0;\n\t}\n\n\t.features article .icon {\n\t\theight: 8em;\n\t\tline-height: 8em;\n\t\twidth: 8em;\n\t}\n\n\t.features article .icon:before {\n\t\tfont-size: 2.25rem;\n\t}\n\n\t.features article .icon:after {\n\t\theight: 6em;\n\t\tmargin: -3em 0 0 -3em;\n\t\twidth: 6em;\n\t}\n}\n\n@media screen and (max-width: 480px) {\n\t.features article {\n\t\t-moz-flex-direction: column;\n\t\t-webkit-flex-direction: column;\n\t\t-ms-flex-direction: column;\n\t\tflex-direction: column;\n\t\t-moz-align-items: -moz-flex-start;\n\t\t-webkit-align-items: -webkit-flex-start;\n\t\t-ms-align-items: -ms-flex-start;\n\t\talign-items: flex-start;\n\t}\n\n\t.features article .icon {\n\t\theight: 6em;\n\t\tline-height: 6em;\n\t\tmargin: 0 0 1.5em 0;\n\t\twidth: 6em;\n\t}\n\n\t.features article .icon:before {\n\t\tfont-size: 1.5rem;\n\t}\n\n\t.features article .icon:after {\n\t\theight: 4em;\n\t\tmargin: -2em 0 0 -2em;\n\t\twidth: 4em;\n\t}\n}\n\n@media screen and (max-width: 480px) {\n\t.features article .icon:before {\n\t\tfont-size: 1.25rem;\n\t}\n}\n\n/* Posts */\n.posts {\n\tdisplay: -moz-flex;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flex;\n\tdisplay: flex;\n\t-moz-flex-wrap: wrap;\n\t-webkit-flex-wrap: wrap;\n\t-ms-flex-wrap: wrap;\n\tflex-wrap: wrap;\n\t/* margin: 0 0 2em -6em; */\n\t/* width: calc(100% + 6em); */\n}\n\n.posts article {\n\t-moz-flex-grow: 0;\n\t-webkit-flex-grow: 0;\n\t-ms-flex-grow: 0;\n\tflex-grow: 0;\n\t-moz-flex-shrink: 1;\n\t-webkit-flex-shrink: 1;\n\t-ms-flex-shrink: 1;\n\tflex-shrink: 1;\n\tmargin: 0 0 6em 6em;\n\tposition: relative;\n\twidth: calc(33.33333% - 6em);\n}\n\n.posts article:before {\n\tbackground: rgba(210, 215, 217, 0.75);\n\tcontent: '';\n\tdisplay: block;\n\theight: calc(100% + 6em);\n\tleft: -3em;\n\tposition: absolute;\n\ttop: 0;\n\twidth: 1px;\n}\n\n.posts article:after {\n\tbackground: rgba(210, 215, 217, 0.75);\n\tbottom: -3em;\n\tcontent: '';\n\tdisplay: block;\n\theight: 1px;\n\tposition: absolute;\n\tright: 0;\n\twidth: calc(100% + 6em);\n}\n\n.posts article> :last-child {\n\tmargin-bottom: 0;\n}\n\n.posts article .image {\n\tdisplay: block;\n\tmargin: 0 0 2em 0;\n}\n\n.posts article .image img {\n\tdisplay: block;\n\twidth: 100%;\n}\n\n@media screen and (min-width: 1681px) {\n\t.posts article:nth-child(3n + 1):before {\n\t\tdisplay: none;\n\t}\n\n\t.posts article:nth-child(3n + 1):after {\n\t\twidth: 100%;\n\t}\n\n\t.posts article:nth-last-child(1),\n\t.posts article:nth-last-child(2),\n\t.posts article:nth-last-child(3) {\n\t\tmargin-bottom: 0;\n\t}\n\n\t.posts article:nth-last-child(1):before,\n\t.posts article:nth-last-child(2):before,\n\t.posts article:nth-last-child(3):before {\n\t\theight: 100%;\n\t}\n\n\t.posts article:nth-last-child(1):after,\n\t.posts article:nth-last-child(2):after,\n\t.posts article:nth-last-child(3):after {\n\t\tdisplay: none;\n\t}\n}\n\n@media screen and (max-width: 1680px) {\n\t.posts article {\n\t\twidth: calc(50% - 6em);\n\t}\n\n\t.posts article:nth-last-child(3) {\n\t\tmargin-bottom: 6em;\n\t}\n}\n\n@media screen and (min-width: 481px) and (max-width: 1680px) {\n\t.posts article:nth-child(2n + 1):before {\n\t\tdisplay: none;\n\t}\n\n\t.posts article:nth-child(2n + 1):after {\n\t\twidth: 100%;\n\t}\n\n\t.posts article:nth-last-child(1),\n\t.posts article:nth-last-child(2) {\n\t\tmargin-bottom: 0;\n\t}\n\n\t.posts article:nth-last-child(1):before,\n\t.posts article:nth-last-child(2):before {\n\t\theight: 100%;\n\t}\n\n\t.posts article:nth-last-child(1):after,\n\t.posts article:nth-last-child(2):after {\n\t\tdisplay: none;\n\t}\n}\n\n@media screen and (max-width: 736px) {\n\t.posts {\n\t\tmargin: 0 0 2em -4.5em;\n\t\twidth: calc(100% + 4.5em);\n\t}\n\n\t.posts article {\n\t\tmargin: 0 0 4.5em 4.5em;\n\t\twidth: calc(50% - 4.5em);\n\t}\n\n\t.posts article:before {\n\t\theight: calc(100% + 4.5em);\n\t\tleft: -2.25em;\n\t}\n\n\t.posts article:after {\n\t\tbottom: -2.25em;\n\t\twidth: calc(100% + 4.5em);\n\t}\n\n\t.posts article:nth-last-child(3) {\n\t\tmargin-bottom: 4.5em;\n\t}\n}\n\n@media screen and (max-width: 480px) {\n\t.posts {\n\t\tmargin: 0 0 2em 0;\n\t\twidth: 100%;\n\t}\n\n\t.posts article {\n\t\tmargin: 0 0 4.5em 0;\n\t\twidth: 100%;\n\t}\n\n\t.posts article:before {\n\t\tdisplay: none;\n\t}\n\n\t.posts article:after {\n\t\twidth: 100%;\n\t}\n\n\t.posts article:last-child {\n\t\tmargin-bottom: 0;\n\t}\n\n\t.posts article:last-child:after {\n\t\tdisplay: none;\n\t}\n}\n\n/* Wrapper */\n#wrapper {\n\t/* display: -moz-flex; */\n\t/* display: -webkit-flex; */\n\t/* display: -ms-flex; */\n\t/* display: flex; */\n\t/* -moz-flex-direction: row-reverse; */\n\t/* -webkit-flex-direction: row-reverse; */\n\t/* -ms-flex-direction: row-reverse; */\n\t/* flex-direction: row-reverse; */\n\tmin-height: 100vh;\n}\n\n/* Main */\n#main {\n\t/* -moz-flex-grow: 1; */\n\t/* -webkit-flex-grow: 1; */\n\t/* -ms-flex-grow: 1; */\n\t/* flex-grow: 1; */\n\t/* -moz-flex-shrink: 1; */\n\t/* -webkit-flex-shrink: 1; */\n\t/* -ms-flex-shrink: 1; */\n\t/* flex-shrink: 1; */\n\twidth: 100%;\n}\n\n#main>.inner,\n#footer>.inner {\n\tpadding: 0 6em 0.1em 6em;\n\tmargin: 0 auto;\n\tmax-width: 110em;\n}\n\n#main>.inner>section {\n\tpadding: 6em 0 4em 0;\n\tborder-top: solid 2px rgba(210, 215, 217, 0.75);\n}\n\n#main>.inner>section:first-of-type {\n\tborder-top: 0 !important;\n}\n\n@media screen and (max-width: 1680px) {\n\n\t#main>.inner,\n\t#footer>.inner {\n\t\tpadding: 0 5em 0.1em 5em;\n\t}\n\n\t#main>.inner>section {\n\t\tpadding: 5em 0 3em 0;\n\t}\n}\n\n@media screen and (max-width: 1280px) {\n\n\t#main>.inner,\n\t#footer>.inner {\n\t\tpadding: 0 4em 0.1em 4em;\n\t}\n\n\t#main>.inner>section {\n\t\tpadding: 4em 0 2em 0;\n\t}\n}\n\n@media screen and (max-width: 736px) {\n\n\t#main>.inner,\n\t#footer>.inner {\n\t\tpadding: 0 2em 0.1em 2em;\n\t}\n\n\t#main>.inner>section {\n\t\tpadding: 3em 0 1em 0;\n\t}\n}\n\n/* Header */\n#header {\n\tdisplay: -moz-flex;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flex;\n\tdisplay: flex;\n\tborder-bottom: solid 5px #a8a9ad;\n\tpadding: 0;\n\tposition: relative;\n}\n\n#header>* {\n\t-moz-flex: 1;\n\t-webkit-flex: 1;\n\t-ms-flex: 1;\n\tflex: 1;\n\tmargin-bottom: 0;\n}\n\n#header .logo {\n\tborder-bottom: 0;\n\tcolor: inherit;\n\tfont-family: \"Roboto Slab\", serif;\n\tfont-size: 1.125em;\n}\n\n#header .icons {\n\ttext-align: right;\n}\n\n@media screen and (max-width: 736px) {\n\t#header .logo {\n\t\tfont-size: 1.25em;\n\t\tmargin: 0;\n\t}\n\n\t#header .icons {\n\t\theight: 5em;\n\t\tline-height: 5em;\n\t\tposition: absolute;\n\t\tright: -0.5em;\n\t\ttop: 0;\n\t}\n}\n\n/* Banner */\n#banner {\n\tpadding: 6em 0 4em 0;\n\tdisplay: -moz-flex;\n\tdisplay: -webkit-flex;\n\tdisplay: -ms-flex;\n\tdisplay: flex;\n}\n\n#banner h1 {\n\tmargin-top: -0.125em;\n}\n\n#banner .content {\n\t-moz-flex-grow: 1;\n\t-webkit-flex-grow: 1;\n\t-ms-flex-grow: 1;\n\tflex-grow: 1;\n\t-moz-flex-shrink: 1;\n\t-webkit-flex-shrink: 1;\n\t-ms-flex-shrink: 1;\n\tflex-shrink: 1;\n\twidth: 50%;\n}\n\n#banner .image {\n\t-moz-flex-grow: 0;\n\t-webkit-flex-grow: 0;\n\t-ms-flex-grow: 0;\n\tflex-grow: 0;\n\t-moz-flex-shrink: 0;\n\t-webkit-flex-shrink: 0;\n\t-ms-flex-shrink: 0;\n\tflex-shrink: 0;\n\tdisplay: block;\n\tmargin: 0 0 2em 4em;\n\twidth: 50%;\n}\n\n#banner .image img {\n\theight: 100%;\n\t-moz-object-fit: cover;\n\t-webkit-object-fit: cover;\n\t-ms-object-fit: cover;\n\tobject-fit: cover;\n\t-moz-object-position: center;\n\t-webkit-object-position: center;\n\t-ms-object-position: center;\n\tobject-position: center;\n\twidth: 100%;\n}\n\n@media screen and (orientation: portrait) {\n\t#banner {\n\t\t-moz-flex-direction: column-reverse;\n\t\t-webkit-flex-direction: column-reverse;\n\t\t-ms-flex-direction: column-reverse;\n\t\tflex-direction: column-reverse;\n\t}\n\n\t#banner h1 br {\n\t\tdisplay: none;\n\t}\n\n\t#banner .content {\n\t\t-moz-flex-grow: 0;\n\t\t-webkit-flex-grow: 0;\n\t\t-ms-flex-grow: 0;\n\t\tflex-grow: 0;\n\t\t-moz-flex-shrink: 0;\n\t\t-webkit-flex-shrink: 0;\n\t\t-ms-flex-shrink: 0;\n\t\tflex-shrink: 0;\n\t\twidth: 100%;\n\t}\n\n\t#banner .image {\n\t\t-moz-flex-grow: 0;\n\t\t-webkit-flex-grow: 0;\n\t\t-ms-flex-grow: 0;\n\t\tflex-grow: 0;\n\t\t-moz-flex-shrink: 0;\n\t\t-webkit-flex-shrink: 0;\n\t\t-ms-flex-shrink: 0;\n\t\tflex-shrink: 0;\n\t\tmargin: 0 0 4em 0;\n\t\theight: 25em;\n\t\tmax-height: 50vh;\n\t\tmin-height: 18em;\n\t\twidth: 100%;\n\t}\n}\n\n@media screen and (orientation: portrait) and (max-width: 480px) {\n\t#banner .image {\n\t\tmax-height: 35vh;\n\t}\n}\n\n/* Footer */\n#footer {\n\tbackground: #f9fafa;\n\tmargin-top: 2em;\n\tborder-top: solid 2px rgba(210, 215, 217, 0.75);\n}\n\n#footer .copyright {\n\tcolor: #9fa3a6;\n\tfont-size: 0.9em;\n}\n\n#footer .copyright a {\n\tcolor: inherit;\n}\n\n#footer h3 {\n\tmargin-top: 2em;\n}\n\n/* Menu */\n#menu ul {\n\t-moz-user-select: none;\n\t-webkit-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none;\n\tcolor: #3d4449;\n\tfont-family: \"Roboto Slab\", serif;\n\tfont-weight: 400;\n\tletter-spacing: 0.075em;\n\tlist-style: none;\n\tmargin-bottom: 0;\n\tpadding: 0;\n\ttext-transform: uppercase;\n}\n\n#menu ul a,\n#menu ul span {\n\tborder-bottom: 0;\n\tcolor: inherit;\n\tcursor: pointer;\n\tdisplay: block;\n\tfont-size: 0.9em;\n\tpadding: 0.625em 0;\n}\n\n#menu ul a:hover,\n#menu ul span:hover {\n\tcolor: #f56a6a;\n}\n\n#menu ul a.opener,\n#menu ul span.opener {\n\t-moz-transition: color 0.2s ease-in-out;\n\t-webkit-transition: color 0.2s ease-in-out;\n\t-ms-transition: color 0.2s ease-in-out;\n\ttransition: color 0.2s ease-in-out;\n\ttext-decoration: none;\n\t-webkit-tap-highlight-color: rgba(255, 255, 255, 0);\n\tposition: relative;\n}\n\n#menu ul a.opener:before,\n#menu ul span.opener:before {\n\t-moz-osx-font-smoothing: grayscale;\n\t-webkit-font-smoothing: antialiased;\n\tdisplay: inline-block;\n\tfont-style: normal;\n\tfont-variant: normal;\n\ttext-rendering: auto;\n\tline-height: 1;\n\ttext-transform: none !important;\n\tfont-family: 'Font Awesome 5 Free';\n\tfont-weight: 900;\n}\n\n#menu ul a.opener:before,\n#menu ul span.opener:before {\n\t-moz-transition: color 0.2s ease-in-out, -moz-transform 0.2s ease-in-out;\n\t-webkit-transition: color 0.2s ease-in-out, -webkit-transform 0.2s ease-in-out;\n\t-ms-transition: color 0.2s ease-in-out, -ms-transform 0.2s ease-in-out;\n\ttransition: color 0.2s ease-in-out, transform 0.2s ease-in-out;\n\tcolor: #9fa3a6;\n\tcontent: '\\f078';\n\tposition: absolute;\n\tright: 0;\n}\n\n#menu ul a.opener:hover:before,\n#menu ul span.opener:hover:before {\n\tcolor: #f56a6a;\n}\n\n#menu ul a.opener.active+ul,\n#menu ul span.opener.active+ul {\n\tdisplay: block;\n}\n\n#menu ul a.opener.active:before,\n#menu ul span.opener.active:before {\n\t-moz-transform: rotate(-180deg);\n\t-webkit-transform: rotate(-180deg);\n\t-ms-transform: rotate(-180deg);\n\ttransform: rotate(-180deg);\n}\n\n#menu>ul>li {\n\tborder-top: solid 1px rgba(210, 215, 217, 0.75);\n\tmargin: 0.5em 0 0 0;\n\tpadding: 0.5em 0 0 0;\n}\n\n#menu>ul>li>ul {\n\tcolor: #9fa3a6;\n\tdisplay: none;\n\tmargin: 0.5em 0 1.5em 0;\n\tpadding-left: 1em;\n}\n\n#menu>ul>li>ul a,\n#menu>ul>li>ul span {\n\tfont-size: 0.8em;\n}\n\n#menu>ul>li>ul>li {\n\tmargin: 0.125em 0 0 0;\n\tpadding: 0.125em 0 0 0;\n}\n\n#menu>ul>li:first-child {\n\tborder-top: 0;\n\tmargin-top: 0;\n\tpadding-top: 0;\n}\n\n#logo {\n\tdisplay: flex;\n\tpadding: 2em !important;\n\tmargin: -1.66667em -1.66667em 3.33333em -1.66667em !important;\n\tbackground-color: #eff1f2 !important;\n\tposition: static;\n}\n\n#logo img {\n\tmargin: auto;\n}\n\n.categorias {\n\ttext-align: center;\n\tmargin-bottom: 3em;\n}\n\n.blocosSistemas {\n\tpadding-bottom: 15px;\n\tbackground-color: whitesmoke;\n\tpadding-top: 15px;\n\tcolor: black;\n\tmargin-bottom: 2.5em !important;\n\ttext-decoration: none;\n}\n\n.riscado {\n\ttext-decoration: line-through;\n\tcolor: #666666 !important;\n}\n\ntd.caixa,\nth.caixa {\n\twidth: 1em;\n\ttext-align: center;\n}\n\ntd.caixa label,\nth.caixa label {\n\tpadding-right: 0 !important;\n}\n\n.contato {\n\tdisplay: flex;\n}\n\n.contato>div {\n\tflex: 1;\n\ttext-indent: -1.8em;\n\tpadding-left: 3em;\n}\n\n.contato>div>svg {\n\tmargin-right: 5px;\n}\n\n.margem-antes {\n\tmargin: 2em 0 0 0;\n}\n\n.botaoIcone {\n\tmargin: 0 !important;\n}\n\ntd {\n\tvertical-align: middle;\n}\n\nbutton {\n\toutline: none !important;\n}\n\n.pad0 {\n\tpadding: 0 !important;\n}\n\n.botao {\n\twidth: 10px;\n}\n\n.botao-voltar {\n\tmargin-right: 1em;\n}\n\nspan.botao {\n\tborder: 1px solid #7f888f;\n\tborder-radius: 4px;\n\tpadding: 0 10px;\n\tcolor: #000000;\n}\n\n\n#mensagem,\n.envio-mensagem {\n\t/*padding: 40px;*/\n\ttext-align: justify;\n\tfont-size: 14pt;\n\tcolor: #000000;\n\tfont-family: Roboto, RobotoDraft, Helvetica, Arial, sans-serif;\n}\n\n.envio-mensagem p {\n\tmargin: 0;\n}\n\n#assinatura,\n.envio-assinatura {\n\tpadding: 20 0 100 0px;\n\ttext-align: center;\n\tfont-size: 14pt;\n\tcolor: #000000;\n\tfont-family: Roboto, RobotoDraft, Helvetica, Arial, sans-serif;\n}\n\n.envio-assinatura p {\n\tmargin: 0;\n}\n\n#versao {\n\tposition: fixed;\n\ttop: 0;\n\tright: 0;\n}\n\n.MuiPaper-root {\n\tpadding: 0em !important;\n\tmargin-bottom: 1em;\n}\n\n.MuiPaper-root div.cabecalho {\n\tbackground-color: lightgray;\n\tpadding: 5px 5px 5px 10px;\n\tfont-weight: 600;\n}\n\n.MuiPaper-root label {\n\tpadding: 15px 15px 15px 15px;\n\tmargin: 0;\n}\n\n.MuiPaper-root select,\n.MuiPaper-root input,\n.MuiPaper-root textarea {\n\tmargin: 0 15px 15px 15px;\n}\n\n.MuiPaper-root input[type=\"checkbox\"] {\n\tmargin: 0;\n}\n\n.MuiTabPanel-root {\n\tpadding: 24px 0 0 0 !important;\n}\n\n.MuiButton-root {\n\tmargin-top: 5px;\n}\n\n@keyframes spinner {\n\t0% {\n\t\ttransform: rotate(0deg);\n\t}\n\n\t100% {\n\t\ttransform: rotate(360deg);\n\t}\n}\n\n.loading-spinner {\n\twidth: 15px;\n\theight: 15px;\n\tborder: 5px solid #f3f3f3;\n\t/* Light grey */\n\tborder-top: 5px solid #ffa500;\n\t/* Black */\n\tborder-radius: 50%;\n\tanimation: spinner 1.5s linear infinite;\n\tfloat: left;\n}\n.situacao {\n\tcolor: orange;\n\twidth: fit-content;\n\tfont-weight: 600;\n\tfloat: left;\n\tmargin-left: 8px;\n}\n\n.MuiCollapse-root {\n\tmargin-right: 15px;\n    margin-top: 10px;\n}\n.css-ki1hdl-MuiAlert-action {\n\tmargin-right: 0 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
